import React, {useState, useEffect, useRef} from "react";
import { keepSavedPricingIfUntouched, savedPricingNotice } from "./editPricingGuard";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import { FormControlLabel } from "@mui/material";
// Büyük formda her tuşta tüm formun yeniden çizilmesini önleyen tamponlu TextField (yazma gecikmesi)
import TextField from "components/BufferedTextField";
import MenuItem from "@mui/material/MenuItem";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Button from "@mui/material/Button";
import CrudService from "services/cruds-service";
import {DatePicker, LocalizationProvider,} from "@mui/x-date-pickers";
import "jspdf-autotable";
import Switch from "@mui/material/Switch";
import Box from "@mui/material/Box";
import {tr} from "date-fns/locale";
import {companies} from "../../companies";
import countryOptions from "../../components/List/Countries";
import {EXTRA_CHARGE_TYPES} from "../../../../../../constants/extraCostAir";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CreateCustomer from "../../crm/customer/CreateCustomer";
import { useNavigate, useLocation } from "react-router-dom";
import CreateServiceProvider from "../../crm/Service Provider/CreateServiceProvider";
import { AddRowButton, RemoveRowButton } from "components/RowActions";
const AirForm = ({ selectedTransportType }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [exchangeRates, setExchangeRates] = useState(null);
    const [loadingRates, setLoadingRates] = useState(false);
    const [serviceProviderOptions, setServiceProviderOptions] = useState([]);
    const [serviceProviderModalOpen, setServiceProviderModalOpen] = useState(false);
    const [serviceProviderModalTargetIndex, setServiceProviderModalTargetIndex] = useState(null);
    const dimensionUnitOptions = ["cm", "mm", "m", "inch"];
    const [dimensionUnit, setDimensionUnit] = useState("cm");

    const NEW_SERVICE_PROVIDER_OPTION = {
        id: "new-service-provider",
        name: "+ New Account",
        type: "new",
    };

    useEffect(() => {
        async function loadRates() {
            setLoadingRates(true);
            try {
                // Example: fetch latest rates with base USD
                const res = await fetch("https://api.exchangerate-api.com/v4/latest/USD");
                if (!res.ok) throw new Error("Failed to fetch exchange rates");
                const data = await res.json();
                // data.rates => { "EUR": 0.9, "TRY": 19.2, "GBP": 0.8, ... } if base=USD
                setExchangeRates(data.rates);
            } catch (err) {
                console.error("Error loading exchange rates:", err);
            } finally {
                setLoadingRates(false);
            }
        }
        loadRates();
    }, []);

    const convertAmount = (amount, fromCurrency, toCurrency) => {
        if (!exchangeRates) return amount;
        if (!fromCurrency || !toCurrency) return amount;
        if (fromCurrency === toCurrency) return amount;

        const amountInUSD = amount / exchangeRates[fromCurrency];
        return amountInUSD * exchangeRates[toCurrency];
    };


    const statusOptions = [
        { value: "Pending",     label: "Pending",     color: "#FFB300" }, // amber
        { value: "Sent",        label: "Sent",        color: "#1E88E5" }, // blue
        { value: "Secured",     label: "Secured",     color: "#43A047" }, // green
        { value: "Lost",        label: "Lost",        color: "#E53935" }, // red
        { value: "Closed",      label: "Closed",      color: "#546E7A" }, // grey-blue
    ];
    const Dot = ({ color }) => (
        <span
            style={{
                display: "inline-block",
                width: 10,
                height: 10,
                borderRadius: "50%",
                backgroundColor: color || "#999",
                marginRight: 8,
                verticalAlign: "middle",
                flexShrink: 0,
            }}
        />
    );

    const serviceOptions = [
        { label: "Port to Port" },
        { label: "Port to Door" },
        { label: "Door to Port" },
        { label: "Door to Door" },
    ];

    const incotermsOptions = [
        { label: "CFR" },
        { label: "CIF" },
        { label: "CIP" },
        { label: "CPT" },
        { label: "DAP" },
        { label: "DAT" },
        { label: "DPU" },
        { label: "DDP" },
        { label: "EXW" },
        { label: "FAS" },
        { label: "FCA" },
        { label: "FOB" },
        { label: "FOT" },
        { label: "FOR" },
    ];
    const [inputValue, setInputValue] = useState("");
    const [open, setOpen] = useState(false);
    const [customerOptions, setCustomerOptions] = useState([]);
    const [partyOptions, setPartyOptions] = useState([]);
    const carrierAirportTimersRef = useRef({});
    const carrierAirportManualRef = useRef({});
    useEffect(() => {
        const fetchOptions = async () => {
            try {
                const [customersRes, agentsRes] = await Promise.all([
                    CrudService.getCustomers(),
                    CrudService.getGlobalAgents(),
                ]);

                const customers = (customersRes.data || []).map((c) => ({
                    id: c.id,
                    name: c.attributes?.name || "Unnamed Customer",
                    type: "customer",
                }));

                const agents = (agentsRes.data || []).map((a) => ({
                    id: a.id,
                    name: a.attributes?.name || a.name || "Unnamed Global Agent",
                    type: "agent",
                }));

                const merged = [...customers, ...agents].sort((x, y) =>
                    (x.name || "").localeCompare(y.name || "")
                );

                setCustomerOptions(customers);  // ✅ EKLE
                setPartyOptions(merged);
            } catch (err) {
                console.error("Options alınırken hata oluştu:", err);
            } finally {
                setCustomersLoaded(true);
            }
        };

        fetchOptions();
    }, []);

// companies (string[]) + partyOptions (object[]) => string[]
    const shipperConsigneeOptions = React.useMemo(() => {
        const companyItems = (companies || [])
            .map((name) => String(name || "").trim())
            .filter(Boolean)
            .map((name) => ({
                id: `company-${name.toLowerCase()}`,
                name,
                type: "company",
            }));

        const partyItems = (partyOptions || [])
            .filter((p) => p?.name)
            .map((p) => ({
                id: `${p.type}-${p.id}`,
                name: String(p.name).trim(),
                type: p.type, // "customer" | "agent"
            }));

        // unique by (type + name) (aynı isim farklı tipte olabilir)
        const map = new Map();
        [...companyItems, ...partyItems].forEach((item) => {
            const key = `${item.type}::${item.name.toLowerCase()}`;
            if (!map.has(key)) map.set(key, item);
        });

        return Array.from(map.values()).sort((a, b) => a.name.localeCompare(b.name));
    }, [partyOptions, companies]);

    const findOptionByName = (name) => {
        const target = String(name || "").trim().toLowerCase();

        if (!target) return null;


        const summaryBuyingCurrency =
            carriers?.[0]?.currency || baseCurrency || "USD";

        const summarySellingCurrency =
            carriers?.[0]?.sellingCarriersRate || baseCurrency || "USD";

        const hasPickupService = serviceLayout.pickup.length > 0;
        const hasDeliveryService = serviceLayout.delivery.length > 0;

        const formatSummaryAmount = (amount) =>
            Number(amount || 0).toLocaleString("en-US", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            });

        const carrierBuyingRows = (carriers || []).map((carrier, index) => ({
            key: `carrier-buying-${index}`,
            label: carrier.chargeType || `Air Freight Cost #${index + 1}`,
            amount: convertAmount(
                Number(carrier.cost || 0),
                carrier.currency || summaryBuyingCurrency,
                summaryBuyingCurrency
            ),
        }));

        const pickupCostForSummary = hasPickupService
            ? convertAmount(
                Number(pickupService.cost || 0),
                pickupService.costCurrency || summaryBuyingCurrency,
                summaryBuyingCurrency
            )
            : 0;

        const deliveryCostForSummary = hasDeliveryService
            ? convertAmount(
                Number(deliveryService.cost || 0),
                deliveryService.costCurrency || summaryBuyingCurrency,
                summaryBuyingCurrency
            )
            : 0;

        const extraBuyingRows = (extraCosts || []).map((extra, index) => ({
            key: `extra-buying-${index}`,
            label: extra.type ? `Extra Cost - ${extra.type}` : `Extra Cost #${index + 1}`,
            amount: convertAmount(
                Number(extra.amount || 0),
                extra.currency || summaryBuyingCurrency,
                summaryBuyingCurrency
            ),
        }));

        const carrierSellingBase = (carriers || []).reduce(
            (sum, carrier) =>
                sum + convertAmount(
                    Number(carrier.sellingCarriers || 0),
                    carrier.sellingCarriersRate || summarySellingCurrency,
                    summarySellingCurrency
                ),
            0
        );

        const pickupSellingForSummary =
            hasPickupService && !pickupService.sellingIncluded
                ? convertAmount(
                    Number(pickupService.selling || 0),
                    pickupService.sellingCurrency || summarySellingCurrency,
                    summarySellingCurrency
                )
                : 0;

        const deliverySellingForSummary =
            hasDeliveryService && !deliveryService.sellingIncluded
                ? convertAmount(
                    Number(deliveryService.selling || 0),
                    deliveryService.sellingCurrency || summarySellingCurrency,
                    summarySellingCurrency
                )
                : 0;

        // Pickup and delivery selling are intentionally merged into Air Freight Selling.
        const combinedAirFreightSelling =
            Number(carrierSellingBase || 0) +
            Number(pickupSellingForSummary || 0) +
            Number(deliverySellingForSummary || 0);

        const extraSellingRows = (extraCosts || []).map((extra, index) => ({
            key: `extra-selling-${index}`,
            label: extra.type ? `Extra Selling - ${extra.type}` : `Extra Selling #${index + 1}`,
            amount: convertAmount(
                Number(extra.extraSelling || 0),
                extra.extraSellingRate || summarySellingCurrency,
                summarySellingCurrency
            ),
        }));

        const summaryTotalBuying =
            carrierBuyingRows.reduce((sum, row) => sum + Number(row.amount || 0), 0) +
            Number(pickupCostForSummary || 0) +
            Number(deliveryCostForSummary || 0) +
            extraBuyingRows.reduce((sum, row) => sum + Number(row.amount || 0), 0);

        const summaryBreakdownSelling =
            Number(combinedAirFreightSelling || 0) +
            extraSellingRows.reduce((sum, row) => sum + Number(row.amount || 0), 0);

        const summaryTotalSelling =
            airPricingMode === "BREAKDOWN" || hasAnySellingInput
                ? summaryBreakdownSelling
                : convertAmount(
                    Number(sellingCalc.finalSelling || 0),
                    baseCurrency,
                    summarySellingCurrency
                );

        return (
            shipperConsigneeOptions.find(
                (o) => String(o.name || "").trim().toLowerCase() === target
            ) || {
                id: `manual-${target}`,
                name,
                type: "manual",
            }
        );
    };

    const handleCustomerCreatedFromModal = (createdCustomer) => {
        const attr = createdCustomer?.attributes || createdCustomer;

        const newOption = {
            id: createdCustomer?.id || attr?._id || Date.now(),
            name: attr?.name || "Unnamed Customer",
            type: "customer",
        };

        setCustomerOptions((prev) => {
            const exists = prev.some(
                (item) =>
                    item.name?.toLowerCase() === newOption.name.toLowerCase()
            );

            return exists ? prev : [...prev, newOption];
        });

        setPartyOptions((prev) => {
            const exists = prev.some(
                (item) =>
                    item.type === "customer" &&
                    item.name?.toLowerCase() === newOption.name.toLowerCase()
            );

            return exists ? prev : [...prev, newOption];
        });

        if (customerModalTarget === "customer") {
            setSelectedCustomer(newOption);
            setInputValue(newOption.name);
        }

        if (customerModalTarget === "shipper") {
            setShipper(newOption.name);
        }

        if (customerModalTarget === "consignee") {
            setConsignee(newOption.name);
        }

        setCustomerModalOpen(false);
        setCustomerModalTarget(null);
    };


    const handleServiceProviderCreatedFromModal = (createdProvider) => {
        const attr = createdProvider?.attributes || createdProvider;

        const newOption = {
            id: createdProvider?.id || attr?._id || Date.now(),
            name: attr?.name || "Unnamed Service Provider",
            type: "serviceProvider",
        };

        setServiceProviderOptions((prev) => {
            const exists = prev.some(
                (item) => item.name?.toLowerCase() === newOption.name.toLowerCase()
            );

            return exists ? prev : [...prev, newOption];
        });

        if (serviceProviderModalTargetIndex === "pickup") {
            setPickupService((prev) => ({ ...prev, serviceProvider: newOption.name }));
        } else if (serviceProviderModalTargetIndex === "delivery") {
            setDeliveryService((prev) => ({ ...prev, serviceProvider: newOption.name }));
        } else if (Number.isInteger(serviceProviderModalTargetIndex)) {
            handleCarrierChange(serviceProviderModalTargetIndex, "name", newOption.name);
        }

        setServiceProviderModalOpen(false);
        setServiceProviderModalTargetIndex(null);
    };

    useEffect(() => {
        const fetchServiceProviders = async () => {
            try {
                const response = await CrudService.getServiceProviders();

                const options = (response.data ?? []).map((item) => ({
                    id: item.id,
                    name: item?.attributes?.name || "Unnamed Service Provider",
                    type: "serviceProvider",
                }));

                setServiceProviderOptions(options);
            } catch (error) {
                console.error("Service Provider verileri alınırken hata oluştu:", error);
                setServiceProviderOptions([]);
            }
        };

        fetchServiceProviders();
    }, []);

    const carrierAccountOptions = React.useMemo(() => {
        const serviceProviders = (serviceProviderOptions || []).map((x) => ({
            ...x,
            type: "serviceProvider",
        }));

        const customersAndAgents = (partyOptions || []).map((x) => ({
            id: `${x.type}-${x.id}`,
            name: x.name,
            type: x.type, // customer | agent
        }));

        const map = new Map();

        [NEW_SERVICE_PROVIDER_OPTION, ...serviceProviders, ...customersAndAgents].forEach((item) => {
            const key = `${item.type}-${String(item.name || "").toLowerCase()}`;
            if (!map.has(key)) map.set(key, item);
        });

        return Array.from(map.values()).sort((a, b) => {
            if (a.type === "new") return -1;
            if (b.type === "new") return 1;
            return String(a.name || "").localeCompare(String(b.name || ""));
        });
    }, [serviceProviderOptions, partyOptions]);

    const [salesRepOptions, setSalesRepOptions] = useState([]);

    useEffect(() => {
        const fetchSalesReps = async () => {
            try {
                const response = await CrudService.getUsers();
                const users = response.data;
                const formattedUsers = users.map(user => ({
                    id: user.id,
                    label: user.attributes.name
                }));
                setSalesRepOptions(formattedUsers);
            } catch (error) {
                console.error("Satış temsilcileri alınamadı:", error);
            } finally {
                setSalesRepsLoaded(true);
            }
        };
        fetchSalesReps();
    }, []);

    const [loading, setLoading] = useState(false); // Yüklenme durumu
    const [isEditing, setIsEditing] = useState(false); // Düzenleme modu
    const searchParams = new URLSearchParams(location.search); // Query parametrelerini yakalıyoruz
    const quotingToolId = searchParams.get("id"); // URL'deki `id` parametresini alıyoruz
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const submittingRef = useRef(false); // çift tıklamada mükerrer kayıt oluşmasın
    const [customersLoaded, setCustomersLoaded] = useState(false);
    const [salesRepsLoaded, setSalesRepsLoaded] = useState(false);
    const [editDataLoaded, setEditDataLoaded] = useState(false);
    const editFetchStartedRef = useRef(false);
    const savedRecordRef = useRef(null); // düzenlenen kaydın DB'deki hali (fiyat koruması için)
    // Kayıttan sonraki yönlendirme: kullanıcı bu sürede sayfadan çıkarsa onu geri tabloya atmasın
    const redirectTimerRef = useRef(null);
    useEffect(() => () => clearTimeout(redirectTimerRef.current), []);
    const successMessageRef = useRef(null); // Ref oluşturuldu
    const [currency, setCurrency] = useState("USD");
    const baseCurrency = currency || "USD";
    const [totalBuying, setTotalBuying] = useState(0);
    const [totalExtraBuying, setTotalExtraBuying] = useState(0);
    const [totalCarrierSelling, setTotalCarrierSelling] = useState(0);
    const [totalExtraSelling, setTotalExtraSelling] = useState(0);
// ✅ Road selling engine (Air)
    const [sellingDriver, setSellingDriver] = useState("PERCENT"); // "PERCENT" | "UNIT" | "SELLING"
    const [activeSellingField, setActiveSellingField] = useState(null); // "PERCENT" | "UNIT" | "SELLING" | null

    const [marginPercentInput, setMarginPercentInput] = useState("");
    const [marginUnitInput, setMarginUnitInput] = useState("");
    const [sellingRateInput, setSellingRateInput] = useState("");
    const [customerModalOpen, setCustomerModalOpen] = useState(false);
    const [customerModalTarget, setCustomerModalTarget] = useState(null);
    const emptyServiceAddress = {
        type: "",
        country: "",
        city: "",
        port: "",
        additionalInfo: "",
    };

    const optionsCache = useRef(new Map());

    const [pickupAddress1, setPickupAddress1] = useState(emptyServiceAddress);
    const [deliveryAddress2, setDeliveryAddress2] = useState(emptyServiceAddress);

    const emptyServicePricing = {
        serviceProvider: "",
        cost: "",
        costCurrency: "USD",
        sellingIncluded: false,
        selling: "",
        sellingCurrency: "USD",
        remarks: "",
    };

    const [pickupService, setPickupService] = useState(emptyServicePricing);
    const [deliveryService, setDeliveryService] = useState(emptyServicePricing);

    const [pickupAddress1Options, setPickupAddress1Options] = useState([]);
    const [deliveryAddress2Options, setDeliveryAddress2Options] = useState([]);

    const [pickupAddress1Loading, setPickupAddress1Loading] = useState(false);
    const [deliveryAddress2Loading, setDeliveryAddress2Loading] = useState(false);
    const NEW_PARTY_OPTION = {
        id: "new-party",
        name: "+ New Account",
        type: "new",
    };
    const [hydratingFromDb, setHydratingFromDb] = useState(false);

    // Düzenlenecek kaydı müşteri/temsilci listeleri yüklendikten sonra yalnızca bir kez çek.
    // Liste sonradan değişirse (ör. modal ile yeni müşteri eklenince) kullanıcının
    // kaydedilmemiş değişiklikleri DB verisiyle ezilmesin.
    useEffect(() => {
        if (!quotingToolId) return;
        setIsEditing(true);
        if (!customersLoaded || !salesRepsLoaded) return;
        if (editFetchStartedRef.current) return;
        editFetchStartedRef.current = true;
        fetchQuotingToolDetails(quotingToolId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [quotingToolId, customersLoaded, salesRepsLoaded]);

    const fetchQuotingToolDetails = async (id) => {
        setLoading(true);
        try {
            const response = await CrudService.getQuotingToolById(id);
            const quotingToolData = response.data.attributes;
            const findCountry = (label) =>
                countryOptions.find((c) => c.label?.trim().toLowerCase() === String(label || "").trim().toLowerCase()) || null;


            // Müşteri ve Temsilci Seçenekleri
            const matchedCustomer = customerOptions.find(
                (opt) =>
                    opt.name?.trim().toLowerCase() ===
                    quotingToolData.customer?.trim().toLowerCase()
            );
            setSelectedCustomer(matchedCustomer || (quotingToolData.customer ? { id: null, name: quotingToolData.customer, type: "customer" } : null)); // listede yoksa kayıttaki adı koru
            setSalesRep(
                Array.isArray(quotingToolData.salesRep)
                    ? salesRepOptions.filter(repOption =>
                        quotingToolData.salesRep.includes(repOption.id)
                    )
                    : []
            );
            setQuoteType(quotingToolData.quoteType ?? "");
            // Metin ve sayısal değerler
            setShipper(quotingToolData.shipper ?? "");
            setCommodity(quotingToolData.commodity ?? "");
            setConsignee(quotingToolData.consignee ?? "");
            setGrossWeight(quotingToolData.grossWeight ?? "");
            setChargeableWeight(quotingToolData.chargeableWeight ?? "");
            setWidth(quotingToolData.width ?? "");
            setLength(quotingToolData.length ?? "");
            setHeight(quotingToolData.height ?? "");
            setVolume(quotingToolData.volume ?? "");
            setQuantity(quotingToolData.quantity ?? "");
            setSpecialHandling(quotingToolData.specialHandling ?? "");
            setOriginAirport(quotingToolData.originAirport ?? "");
            setDestinationAirport(quotingToolData.destinationAirport ?? "");
            setFinalDestination(quotingToolData.finalDestination ?? "");
            setOriginCountry(findCountry(quotingToolData.polCountry));
            setDestCountry(findCountry(quotingToolData.podCountry));
            setFinalCountry(findCountry(quotingToolData.finalCountry));
            setQuoteNo(quotingToolData.quoteNo ?? "");
            setTransitTime(quotingToolData.transitTime ?? "");
            setOriginFreeTime(quotingToolData.originFreeTime ?? "");
            setDestinationFreeTime(quotingToolData.destinationFreeTime ?? "");
            setSelectedStatus(quotingToolData.status ?? "");
            setSelectedService(quotingToolData.service ?? "");
            setSelectedIncoterm(quotingToolData.incoterm ?? "");
            setDimensionUnit(quotingToolData.dimensionUnit || "cm");
            setEstimatedCloseDate(
                quotingToolData.estimatedCloseDate
                    ? new Date(quotingToolData.estimatedCloseDate)
                    : null,
            );

            setQuoteDate(
                quotingToolData.quoteDate ? new Date(quotingToolData.quoteDate) : null,
            );
            setHydratingFromDb(true);
            setPickupAddress1(quotingToolData.pickupAddress1 || emptyServiceAddress);
            setDeliveryAddress2(quotingToolData.deliveryAddress2 || emptyServiceAddress);
            setPickupService({
                ...emptyServicePricing,
                ...(quotingToolData.pickupService || {}),
                cost: quotingToolData.pickupService?.cost ?? "",
                selling: quotingToolData.pickupService?.selling ?? "",
                costCurrency: quotingToolData.pickupService?.costCurrency || quotingToolData.carriers?.[0]?.currency || "USD",
                sellingCurrency: quotingToolData.pickupService?.sellingCurrency || quotingToolData.carriers?.[0]?.sellingCarriersRate || "USD",
                sellingIncluded: Boolean(quotingToolData.pickupService?.sellingIncluded),
            });
            setDeliveryService({
                ...emptyServicePricing,
                ...(quotingToolData.deliveryService || {}),
                cost: quotingToolData.deliveryService?.cost ?? "",
                selling: quotingToolData.deliveryService?.selling ?? "",
                costCurrency: quotingToolData.deliveryService?.costCurrency || quotingToolData.carriers?.[0]?.currency || "USD",
                sellingCurrency: quotingToolData.deliveryService?.sellingCurrency || quotingToolData.carriers?.[0]?.sellingCarriersRate || "USD",
                sellingIncluded: Boolean(quotingToolData.deliveryService?.sellingIncluded),
            });
            const mode = quotingToolData.airPricingMode || "ALL_IN";
            const savedSelling = Number(quotingToolData.sallingRate || quotingToolData.sellingRate || 0);

            setAirPricingMode(mode);

// ALL_IN: savedSelling'i input'a yaz
            if (mode === "ALL_IN") {
                setSellingDriver("SELLING");
                setSellingRateInput(savedSelling ? String(savedSelling) : "");
                setMarginPercentInput("");
                setMarginUnitInput("");
            } else {
                // BREAKDOWN: inputları da doldur (read-only)
                setSellingDriver("SELLING");
                setSellingRateInput(savedSelling ? String(savedSelling) : "0");
            }

            setTimeout(() => setHydratingFromDb(false), 0);

            setSallingRate(quotingToolData.sallingRate ?? "");
            setCurrency(quotingToolData.currency ?? "");
            setDescription(quotingToolData.description ?? "");
            // ===== CARRIERS (EDIT MODE) =====
            if (Array.isArray(quotingToolData.carriers)) {
                setCarriers(
                    quotingToolData.carriers.map(c => ({
                        name: c.name || "",
                        chargeType: c.chargeType || "Air Freight",
                        cost: c.cost || "",
                        currency: c.currency || "USD",
                        sellingCarriers: c.sellingCarriers || "",
                        sellingCarriersRate: c.sellingCarriersRate || "USD",

                        // STRING → OBJECT (Autocomplete için)
                        polCountry: c.polCountry
                            ? countryOptions.find(x => x.label === c.polCountry) || null
                            : null,

                        pol: c.pol ? { label: c.pol } : null,
                        polInput: c.pol || "",

                        podCountry: c.podCountry
                            ? countryOptions.find(x => x.label === c.podCountry) || null
                            : null,

                        pod: c.pod ? { label: c.pod } : null,
                        podInput: c.pod || "",
                    }))
                );
            }

            if (Array.isArray(quotingToolData.extraCosts)) {
                setExtraCosts(
                    quotingToolData.extraCosts.map(e => ({
                        type: e.type || "",
                        amount: e.amount || "",
                        currency: e.currency || "USD",
                        extraSelling: e.extraSelling || "",
                        extraSellingRate: e.extraSellingRate || "USD",
                    }))
                );
            }
            setAirPricingMode(quotingToolData.airPricingMode || "ALL_IN");
            setCreatedSource(quotingToolData.createdSource || quotingToolData.source || quotingToolData.creationType || "manual");
            setPrefillRefId(quotingToolData.prefillRefId || null);


            // yalnızca tüm alanlar hatasız yüklendiyse kaydetmeye izin ver (yarım form DB yi ezmesin)
            savedRecordRef.current = quotingToolData;
            setEditDataLoaded(true);
        } catch (error) {
            console.error("Error fetching QuotingTool details:", error);
        } finally {
            setLoading(false);
        }
    };




    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [salesRep, setSalesRep] = useState([]);
    const [consignee, setConsignee] = useState("");
    const [grossWeight, setGrossWeight] = useState("");
    const [chargeableWeight, setChargeableWeight] = useState("");
    const [volume, setVolume] = useState("");
    const [width, setWidth] = useState("");
    const [length, setLength] = useState("");
    const [height, setHeight] = useState("");
    const [quantity, setQuantity] = useState("");
    const [specialHandling, setSpecialHandling] = useState("");
    const [originAirport, setOriginAirport] = useState("");
    const [destinationAirport, setDestinationAirport] = useState("");
    const [finalDestination, setFinalDestination] = useState("");
    const [quoteNo, setQuoteNo] = useState("");
    const [transitTime, setTransitTime] = useState("");
    const [originFreeTime, setOriginFreeTime] = useState("");
    const [destinationFreeTime, setDestinationFreeTime] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
    const [selectedService, setSelectedService] = useState("");
    const [selectedIncoterm, setSelectedIncoterm] = useState("");
    const [shipper, setShipper] = useState("");
    const [commodity, setCommodity] = useState("");
    const [estimatedCloseDate, setEstimatedCloseDate] = useState(null);
    const [quoteDate, setQuoteDate] = useState(null);
    const [quoteType, setQuoteType] = useState(null);
    const [sallingRate, setSallingRate] = useState("");
    const [description, setDescription] = useState("");
    const airportReqRef = useRef({ origin: 0, dest: 0, final: 0 });
    const airportCacheRef = useRef({}); // { "Turkey": [{label:"IST - Istanbul", raw:{...}}] }
    const [originCountry, setOriginCountry] = useState(null);
    const [destCountry, setDestCountry] = useState(null);
    const [finalCountry, setFinalCountry] = useState(null);
    const [originAirportOptions, setOriginAirportOptions] = useState([]);
    const [destAirportOptions, setDestAirportOptions] = useState([]);
    const [finalAirportOptions, setFinalAirportOptions] = useState([]);
    const [originAirportLoading, setOriginAirportLoading] = useState(false);
    const [destAirportLoading, setDestAirportLoading] = useState(false);
    const [finalAirportLoading, setFinalAirportLoading] = useState(false);
    const [originSelected, setOriginSelected] = useState(null);
    const [carrierAirportOptions, setCarrierAirportOptions] = useState({});
    const [airPricingMode, setAirPricingMode] = useState("ALL_IN");
    const [marginPercent, setMarginPercent] = useState("");
    const [marginPerUnit, setMarginPerUnit] = useState("");
    const [createdSource, setCreatedSource] = useState("manual");
    const [prefillRefId, setPrefillRefId] = useState(null);
    // Quote type değişince ek masraf tipleri o tipe ait listeden seçilmeli; ama ilk atamada
    // (DB den yükleme veya RFQ prefill) yüklenen tipler silinmesin.
    const prevQuoteTypeRef = useRef(quoteType);
    useEffect(() => {
        const prevQuoteType = prevQuoteTypeRef.current;
        prevQuoteTypeRef.current = quoteType;
        if (!prevQuoteType || prevQuoteType === quoteType) return;
        setExtraCosts(prev =>
            prev.map(e => ({ ...e, type: "" }))
        );
    }, [quoteType]);
    const extraChargeOptions = React.useMemo(() => {
        if (!quoteType || !EXTRA_CHARGE_TYPES[quoteType]) return [];

        return Object.entries(EXTRA_CHARGE_TYPES[quoteType]).flatMap(
            ([group, items]) =>
                items.map((item) => ({
                    label: item,
                    group,
                }))
        );
    }, [quoteType]);

    const [carriers, setCarriers] = useState([
        {
            name: "",
            chargeType: "Air Freight",
            cost: "",
            currency: "USD",
            sellingCarriers: "",
            sellingCarriersRate: "USD",
            polCountry: null,
            pol: null,
            polInput: "",
            podCountry: null,
            pod: null,
            podInput: "",
        },
    ]);


    const [extraCosts, setExtraCosts] = useState([
        {
            type: "",
            amount: "",
            currency: "USD",
            extraSelling: "",
            extraSellingRate: "USD",
        },
    ]);


    useEffect(() => {
        if (!isEditing) return;
        if (!originAirport) return;
        if (originSelected?.label) return;
        if (!originAirportOptions.length) {
            setOriginSelected({ label: originAirport });
            return;
        }
        const found = originAirportOptions.find((x) => x.label === originAirport);
        setOriginSelected(found || { label: originAirport });
    }, [isEditing, originAirportOptions, originAirport]);


    const rfqAppliedRef = useRef(false);

    const norm = (v) => String(v || "").trim().toLowerCase();
    const asDate = (v) => {
        if (!v) return null;
        const d = new Date(v);
        return isNaN(d.getTime()) ? null : d;
    };
    const asNumberStr = (v) => {
        if (v === null || v === undefined || v === "") return "";
        const n = Number(v);
        return Number.isFinite(n) ? String(n) : "";
    }

    const getServiceLayout = (service) => {
        switch ((service || "").trim()) {
            case "Door to Door":
                return {
                    pickup: [{ key: "pickupAddress1", type: "door", label: "Pickup / Loading Address" }],
                    delivery: [{ key: "deliveryAddress2", type: "door", label: "Delivery Address" }],
                };

            case "Door to Port":
                return {
                    pickup: [{ key: "pickupAddress1", type: "door", label: "Pickup / Loading Address" }],
                    delivery: [],
                };

            case "Port to Door":
                return {
                    pickup: [],
                    delivery: [{ key: "deliveryAddress2", type: "door", label: "Delivery Address" }],
                };

            case "Port to Port":
            default:
                return { pickup: [], delivery: [] };
        }
    };

    const serviceLayout = React.useMemo(
        () => getServiceLayout(selectedService),
        [selectedService]
    );

    const normalizeLocationOptions = (payload) => {
        const raw = payload?.data?.data || payload?.data || payload || [];
        const arr = Array.isArray(raw) ? raw : [];

        return arr
            .map((x) => {
                if (typeof x === "string") return x;
                const code = x?.iata || x?.IATA || x?.code || x?.airportCode || "";
                const name = x?.name || x?.airportName || x?.city || x?.label || x?.value || "";
                if (code && name) return `${code} - ${name}`;
                return code || name;
            })
            .filter(Boolean);
    };

    const getLocationKindFromType = (type) => {
        if (type === "door") return "city";
        if (type === "port") return "airport";
        return null;
    };

    const fetchOptionsByCountryAndType = async (country, type) => {
        if (!country || !type) return [];

        const kind = getLocationKindFromType(type);
        if (!kind) return [];

        const cacheKey = `${kind}:${country}`;
        const cached = optionsCache.current.get(cacheKey);

        if (cached?.length) return cached;

        try {
            const res =
                kind === "city"
                    ? await CrudService.getCitiesByCountry(country)
                    : await CrudService.getAirportsByCountryOpp(country);

            const list = normalizeLocationOptions(res);

            if (list.length) optionsCache.current.set(cacheKey, list);
            else optionsCache.current.delete(cacheKey);

            return list;
        } catch (error) {
            console.error("Location options fetch failed:", { country, type, error });
            optionsCache.current.delete(cacheKey);
            return [];
        }
    };

    useEffect(() => {
        const layout = getServiceLayout(selectedService);

        const hasPickup = layout.pickup.some((x) => x.key === "pickupAddress1");
        const hasDelivery = layout.delivery.some((x) => x.key === "deliveryAddress2");

        if (!hasPickup) {
            setPickupAddress1(emptyServiceAddress);
            setPickupService(emptyServicePricing);
        }
        if (!hasDelivery) {
            setDeliveryAddress2(emptyServiceAddress);
            setDeliveryService(emptyServicePricing);
        }
    }, [selectedService]);

    useEffect(() => {
        if (!pickupAddress1.country || !pickupAddress1.type) {
            setPickupAddress1Options([]);
            return;
        }

        setPickupAddress1Loading(true);
        fetchOptionsByCountryAndType(pickupAddress1.country, pickupAddress1.type)
            .then(setPickupAddress1Options)
            .finally(() => setPickupAddress1Loading(false));
    }, [pickupAddress1.country, pickupAddress1.type]);

    useEffect(() => {
        if (!deliveryAddress2.country || !deliveryAddress2.type) {
            setDeliveryAddress2Options([]);
            return;
        }

        setDeliveryAddress2Loading(true);
        fetchOptionsByCountryAndType(deliveryAddress2.country, deliveryAddress2.type)
            .then(setDeliveryAddress2Options)
            .finally(() => setDeliveryAddress2Loading(false));
    }, [deliveryAddress2.country, deliveryAddress2.type]);

    const findCountry = (label) =>
        countryOptions.find((c) => norm(c.label) === norm(label)) || null;

// companies string[] ise string dön, object[] ise match et
    const matchCompany = (val) => {
        if (!val) return "";
        const key = norm(val);
        if (!key) return "";

        // companies string[] ise
        if (typeof companies?.[0] === "string") {
            return companies.find((x) => norm(x) === key) || val;
        }

        // companies object[] ise (label/name)
        return (
            companies.find((x) => norm(x?.label ?? x?.name ?? x) === key) ||
            val
        );
    };

    const findCountryByLabel = (label) => countryOptions.find((c) => norm(c.label) === norm(label)) || null;

    useEffect(() => {
        const rfqPayload =
            location?.state?.rfq ||
            location?.state?.data ||
            location?.state?.payload ||
            null;

        const prefill =
            location?.state?.prefill ||
            location?.state?.prefillData ||
            location?.state?.rfqPrefill ||
            null;

        // ✅ tek payload: rfq varsa rfq, yoksa prefill
        const payload = rfqPayload || prefill;

        // ✅ sadece CREATE modunda
        if (quotingToolId) return;
        if (isEditing) return;
        if (!payload) return;

        // ✅ options hazır değilse bekle
        const needsCustomer = !!(payload.customerId || payload.customerName || payload.customer);
        const repIds = payload.salesRepIds || payload.salesRep || [];
        const needsReps = Array.isArray(repIds) && repIds.length > 0;

        if (needsCustomer && customerOptions.length === 0) return;
        if (needsReps && salesRepOptions.length === 0) return;

        if (rfqAppliedRef.current) return;

        // ---- QUOTE TYPE
        if (payload.quoteType) setQuoteType(payload.quoteType);

        // ---- CUSTOMER
        const customerName =
            payload.customerName ||
            payload.customer?.name ||
            payload.customer ||
            "";

        const matchedCustomer =
            (payload.customerId
                ? customerOptions.find((x) => String(x.id) === String(payload.customerId))
                : null) ||
            customerOptions.find((x) => norm(x.name) === norm(customerName)) ||
            null;

        if (matchedCustomer) {
            setSelectedCustomer(matchedCustomer);
            setInputValue(matchedCustomer.name);
            setOpen(false);
        }

        // ---- SALES REPS
        if (needsReps) {
            const idSet = new Set(repIds.map((x) => String(x)));
            setSalesRep(salesRepOptions.filter((x) => idSet.has(String(x.id))));
        }

        // ---- GENEL
        if (payload.shipper) setShipper(matchCompany(payload.shipper));
        if (payload.consignee) setConsignee(matchCompany(payload.consignee));
        if (payload.commodity) setCommodity(payload.commodity);

        if (payload.quantity != null) setQuantity(asNumberStr(payload.quantity));
        if (payload.width != null) setWidth(asNumberStr(payload.width));
        if (payload.length != null) setLength(asNumberStr(payload.length));
        if (payload.height != null) setHeight(asNumberStr(payload.height));
        if (payload.volume != null) setVolume(asNumberStr(payload.volume));
        if (payload.grossWeight != null) setGrossWeight(asNumberStr(payload.grossWeight));
        if (payload.chargeableWeight != null) setChargeableWeight(asNumberStr(payload.chargeableWeight));

        if (payload.specialHandling) setSpecialHandling(payload.specialHandling);

        if (payload.quoteDate) setQuoteDate(asDate(payload.quoteDate));
        if (payload.estimatedCloseDate) setEstimatedCloseDate(asDate(payload.estimatedCloseDate));

        if (payload.serviceMode) setSelectedService(payload.serviceMode);
        if (payload.incoterm) setSelectedIncoterm(payload.incoterm);

        if (payload.transitTime != null) setTransitTime(asNumberStr(payload.transitTime));
        if (payload.originFreeTime != null) setOriginFreeTime(asNumberStr(payload.originFreeTime));
        if (payload.destinationFreeTime != null) setDestinationFreeTime(asNumberStr(payload.destinationFreeTime));

        if (payload.airPricingMode) setAirPricingMode(payload.airPricingMode);
        if (payload.currency) setCurrency(payload.currency);

        // ✅ COUNTRY + AIRPORT (rfq + prefill ortak alan isimleri)
        const originCountryLabel =
            payload.polCountry ||
            payload.originCountry ||
            payload.origin ||
            "";

        const destCountryLabel =
            payload.podCountry ||
            payload.destinationCountry ||
            payload.destination ||
            "";

        const originAirportLabel =
            payload.originAirport ||
            payload.pol ||
            payload.originAirportCode ||
            "";

        const destAirportLabel =
            payload.destinationAirport ||
            payload.pod ||
            payload.destinationAirportCode ||
            "";

        // Top-level istersen kalsın
        if (originCountryLabel) setOriginCountry(findCountryByLabel(originCountryLabel) || { label: originCountryLabel });
        if (destCountryLabel) setDestCountry(findCountryByLabel(destCountryLabel) || { label: destCountryLabel });

        if (originAirportLabel) setOriginAirport(String(originAirportLabel));
        if (destAirportLabel) setDestinationAirport(String(destAirportLabel));

        // ✅ UI carriers[0] üzerinden doluyor → carriers[0] set
        setCarriers((prev) => {
            const first = prev?.[0] || {};

            const polCountryObj = originCountryLabel
                ? (findCountryByLabel(originCountryLabel) || { label: originCountryLabel })
                : null;

            const podCountryObj = destCountryLabel
                ? (findCountryByLabel(destCountryLabel) || { label: destCountryLabel })
                : null;

            return [
                {
                    ...first,
                    polCountry: polCountryObj,
                    podCountry: podCountryObj,

                    pol: originAirportLabel ? { label: String(originAirportLabel) } : null,
                    polInput: originAirportLabel ? String(originAirportLabel) : "",

                    pod: destAirportLabel ? { label: String(destAirportLabel) } : null,
                    podInput: destAirportLabel ? String(destAirportLabel) : "",
                },
                ...(prev?.slice(1) || []),
            ];
        });

        // ✅ dropdown options’ları da yükle
        (async () => {
            try {
                if (originCountryLabel) {
                    const opts = await fetchAirportsByCountry(originCountryLabel);
                    setCarrierAirportOptions((p) => ({ ...p, 0: opts }));
                }
                if (destCountryLabel) {
                    const opts = await fetchAirportsByCountry(destCountryLabel);
                    setCarrierAirportOptions((p) => ({ ...p, "pod-0": opts }));
                }
            } catch {}
        })();

        // ✅ EN SON kilitle
        rfqAppliedRef.current = true;
    }, [location.state, quotingToolId, isEditing, customerOptions, salesRepOptions]);

    const prefill =
        location.state?.prefill ||
        location.state?.prefillData ||
        location.state?.rfqPrefill ||
        null;


    useEffect(() => {
        if (!prefill) return;
        if (quotingToolId) return; // edit modunda ezme

        setCreatedSource("prefill");

        // RFQ id / ref nerede ise onu yaz
        setPrefillRefId(
            prefill?.id ||
            prefill?.rfqId ||
            prefill?.rfqNumber ||
            prefill?.prefillRefId ||
            null
        );

    }, [prefill, quotingToolId]);
    const normalizeAirportLabel = (item) => {
        if (!item) return "";

        // 🔴 API STRING dönüyorsa
        if (typeof item === "string") {
            return item.trim();
        }

        const code =
            item.iata ||
            item.IATA ||
            item.code ||
            item.airportCode ||
            "";

        const name =
            item.name ||
            item.airportName ||
            item.city ||
            "";

        if (code && name) return `${code} - ${name}`;
        return (code || name || "").trim();
    };


// country seçilince full liste getir (cache’li)
    const fetchAirportsByCountry = async (countryLabel, query = "") => {
        const c = String(countryLabel || "").trim();
        const q = String(query || "").trim();

        if (!c || q.length < 2) return [];

        const cacheKey = `${c}:${q.toLowerCase()}`;

        if (airportCacheRef.current[cacheKey]) {
            return airportCacheRef.current[cacheKey];
        }

        const res = await CrudService.getAirportsByCountryOpp(c, {
            params: { q },
        });

        const raw = res?.data?.data || [];

        const options = raw.map((item) => ({
            label: normalizeAirportLabel(item),
            raw: item,
        }));

        airportCacheRef.current[cacheKey] = options;

        return options;
    };
    const normalizeQuery = (q) => {
        if (!q) return "";
        if (typeof q === "string") return q.trim();
        if (typeof q === "object" && q.label) return q.label.trim();
        return "";
    };

// country + query ile search (config.params.q)
    const searchAirports = async ({ query, country, setter, setLoading, key }) => {
        const q = normalizeQuery(query);
        const c = String(country || "").trim();

        if (!c || q.length < 2) {
            setter([]);
            return;
        }

        airportReqRef.current[key] = (airportReqRef.current[key] || 0) + 1;
        const reqId = airportReqRef.current[key];

        try {
            if (typeof setLoading === "function") {
                setLoading(true);
            }

            const opts = await fetchAirportsByCountry(c, q);

            if (reqId !== airportReqRef.current[key]) return;

            setter(opts);
        } catch (e) {
            console.error("Airport search error:", e);
            setter([]);
        } finally {
            if (typeof setLoading === "function") {
                setLoading(false);
            }
        }
    };
// ---- effects (input debounce => search OR full list)
    useEffect(() => {
        const c = originCountry?.label;
        const q = String(originAirport || "").trim();

        setOriginAirportOptions([]);

        if (!c || q.length < 2) return;

        const t = setTimeout(() => {
            searchAirports({
                query: q,
                country: c,
                setter: setOriginAirportOptions,
                setLoading: setOriginAirportLoading,
                key: "origin",
            });
        }, 300);

        return () => clearTimeout(t);
    }, [originAirport, originCountry?.label]);

    useEffect(() => {
        const c = destCountry?.label;
        const q = String(destinationAirport || "").trim();

        setDestAirportOptions([]);

        if (!c || q.length < 2) return;

        const t = setTimeout(() => {
            searchAirports({
                query: q,
                country: c,
                setter: setDestAirportOptions,
                setLoading: setDestAirportLoading,
                key: "dest",
            });
        }, 300);

        return () => clearTimeout(t);
    }, [destinationAirport, destCountry?.label]);


    useEffect(() => {
        const c = finalCountry?.label;
        const q = String(finalDestination || "").trim();

        setFinalAirportOptions([]);

        if (!c || q.length < 2) return;

        const t = setTimeout(() => {
            searchAirports({
                query: q,
                country: c,
                setter: setFinalAirportOptions,
                setLoading: setFinalAirportLoading,
                key: "final",
            });
        }, 300);

        return () => clearTimeout(t);
    }, [finalDestination, finalCountry?.label]);

    const getAirportValue = (selected, input, refValue) => {
        const selectedValue =
            typeof selected === "string"
                ? selected
                : selected?.label || "";

        return String(selectedValue || input || refValue || "").trim();
    };

    const normalizeCarriersForApi = (carriers) =>
        carriers.map((c, index) => ({
            name: c.name || "",
            chargeType: c.chargeType || "",
            cost: Number(c.cost || 0),
            currency: c.currency || "",
            sellingCarriers: Number(c.sellingCarriers || 0),
            sellingCarriersRate: c.sellingCarriersRate || "",

            polCountry: c.polCountry?.label || "",
            pol: getAirportValue(
                c.pol,
                c.polInput,
                carrierAirportManualRef.current[`pol-${index}`]
            ),

            podCountry: c.podCountry?.label || "",
            pod: getAirportValue(
                c.pod,
                c.podInput,
                carrierAirportManualRef.current[`pod-${index}`]
            ),
        }));
    const normalizeExtraCostsForApi = (extraCosts) =>
        extraCosts.map(e => ({
            type: e.type || "",
            amount: Number(e.amount || 0),
            currency: e.currency || "",
            extraSelling: Number(e.extraSelling || 0),
            extraSellingRate: e.extraSellingRate || "",
        }));


    const submitHandler = async (e) => {
        e.preventDefault();
        if (submittingRef.current) return;
        if (quotingToolId && !editDataLoaded) {
            setErrorMessage("Quote details could not be loaded. Please reload the page before saving.");
            window.scrollTo({ top: 0, behavior: "smooth" });
            return;
        }
        if (!selectedCustomer) {
            setErrorMessage("Please select a customer before saving.");
            window.scrollTo({ top: 0, behavior: "smooth" });
            return;
        }
        if (!quoteType) {
            setErrorMessage("Please select a quote type (Import / Export / Domestic / Transit) before saving.");
            window.scrollTo({ top: 0, behavior: "smooth" });
            return;
        }
        setErrorMessage("");
        submittingRef.current = true;

        const quotingToolData = {
            quoteType,
            customer: selectedCustomer?.name || "Unknown Customer", // name alanını kullanın
            salesRep: salesRep.map(rep => rep.id),
            shipper,
            commodity,
            consignee,
            grossWeight,
            chargeableWeight,
            volume,
            width,
            length,
            height,
            quantity,
            specialHandling,
            quoteNo,
            estimatedCloseDate,
            quoteDate,
            status: selectedStatus,
            service: selectedService,
            transitTime,
            originFreeTime,
            destinationFreeTime,
            description,
            selectedTransportType,
            airPricingMode,
            carriers: normalizeCarriersForApi(carriers),
            extraCosts: normalizeExtraCostsForApi(extraCosts),
            totalCarrierSelling,
            totalExtraSelling,
            sallingRate: Number(sellingCalc.finalSelling) || 0,
            marginPercent: marginPercentInput,
            marginPerUnit: marginUnitInput,
            currency,
            incoterm: selectedIncoterm,
            createdSource,
            prefillRefId,
            dimensionUnit,
            pickupAddress1: { ...pickupAddress1, type: pickupAddress1.type || "door" },
            deliveryAddress2: { ...deliveryAddress2, type: deliveryAddress2.type || "door" },
            pickupService: serviceLayout.pickup.length
                ? {
                    serviceProvider: pickupService.serviceProvider || "",
                    cost: Number(pickupService.cost || 0),
                    costCurrency: pickupService.costCurrency || carriers?.[0]?.currency || "USD",
                    sellingIncluded: Boolean(pickupService.sellingIncluded),
                    selling: pickupService.sellingIncluded ? 0 : Number(pickupService.selling || 0),
                    sellingCurrency: pickupService.sellingCurrency || carriers?.[0]?.sellingCarriersRate || "USD",
                    remarks: pickupService.remarks || "",
                }
                : null,
            deliveryService: serviceLayout.delivery.length
                ? {
                    serviceProvider: deliveryService.serviceProvider || "",
                    cost: Number(deliveryService.cost || 0),
                    costCurrency: deliveryService.costCurrency || carriers?.[0]?.currency || "USD",
                    sellingIncluded: Boolean(deliveryService.sellingIncluded),
                    selling: deliveryService.sellingIncluded ? 0 : Number(deliveryService.selling || 0),
                    sellingCurrency: deliveryService.sellingCurrency || carriers?.[0]?.sellingCarriersRate || "USD",
                    remarks: deliveryService.remarks || "",
                }
                : null,
            buyingCurrency: carriers?.[0]?.currency || baseCurrency,
            sellingCurrency: carriers?.[0]?.sellingCarriersRate || baseCurrency,
            totalBuyingCurrency: carriers?.[0]?.currency || baseCurrency,
            totalSellingCurrency: carriers?.[0]?.sellingCarriersRate || baseCurrency
        };
        // Fiyat girdileri değişmediyse kayıtlı fiyat/marj/toplamlar korunur (kur veya kural farkı fiyatı değiştirmesin)
        if (isEditing) keepSavedPricingIfUntouched(quotingToolData, savedRecordRef.current, useLineSelling);
        try {
            setLoading(true);

            let response;
            if (isEditing) {
                response = await CrudService.updateQuotingTool(quotingToolData, quotingToolId);
                setSuccessMessage("Update operation was successfully completed."); // Güncelleme mesajı
            } else {
                response = await CrudService.createQuotingTool({
                    data: quotingToolData,
                });
                // Backend'den dönen quoteNo değerini al ve formda göster
                const newQuoteNo = response.data?.data?.attributes?.quoteNo;
                if (newQuoteNo) {
                    setQuoteNo(newQuoteNo); // Yeni quoteNo'yu state'e ata
                }

                setSuccessMessage("Create operation was successfully completed."); // Kayıt mesajı
            }
            window.scrollTo({ top: 0, behavior: "smooth" });
            redirectTimerRef.current = setTimeout(() => {
                navigate("/quoting-tool/quoting-tool-tables/details");
            }, 3000);
        } catch (err) {
            console.error("Request failed: ", err);
            submittingRef.current = false;
            setErrorMessage(err?.errors?.[0]?.detail || err?.message || "Save failed. Please try again.");
            window.scrollTo({ top: 0, behavior: "smooth" });
        } finally {
            setLoading(false);
        }
    };

    // Teklif numarasını kayıt sırasında backend verir (yeni teklifte alan "Auto-generated" gösterir)

    const clearLineSelling = React.useCallback(() => {
        setCarriers((prev) =>
            (prev || []).map((c) => ({
                ...c,
                sellingCarriers: "",
                // istersen rate kalsın:
                sellingCarriersRate: c.sellingCarriersRate || baseCurrency,
            }))
        );

        setExtraCosts((prev) =>
            (prev || []).map((e) => ({
                ...e,
                extraSelling: "",
                extraSellingRate: e.extraSellingRate || baseCurrency,
            }))
        );

        setPickupService((prev) => ({
            ...prev,
            selling: "",
            sellingCurrency: prev.sellingCurrency || baseCurrency,
            sellingIncluded: false,
        }));

        setDeliveryService((prev) => ({
            ...prev,
            selling: "",
            sellingCurrency: prev.sellingCurrency || baseCurrency,
            sellingIncluded: false,
        }));
    }, [baseCurrency]);

    const handleSwitchChangeQuotingType = (type) => {
        setQuoteType((prevType) => (prevType === type ? "" : type));
    };

    // 📌 Kullanıcının değiştirdiği değerleri güncelle
    const handleInputChange = (setter) => (e) => {
        const value = Number(e.target.value) || 0;
        setter(value);
    };

    const inputStyle = {"& .MuiOutlinedInput-input": { padding: "10 14px" },};

    const handleCarrierChange = async (index, field, value) => {
        setCarriers((prev) =>
            prev.map((c, i) => {
                if (i !== index) return c;

                const next = { ...c, [field]: value };

                if (field === "polCountry") {
                    next.pol = null;
                    next.polInput = "";
                }

                if (field === "podCountry") {
                    next.pod = null;
                    next.podInput = "";
                }

                return next;
            })
        );

        if (field === "polCountry" && value?.label) {
            const opts = await fetchOptionsByCountryAndType(value.label, "port");
            setCarrierAirportOptions((prev) => ({ ...prev, [index]: opts }));
        }

        if (field === "podCountry" && value?.label) {
            const opts = await fetchOptionsByCountryAndType(value.label, "port");
            setCarrierAirportOptions((prev) => ({ ...prev, [`pod-${index}`]: opts }));
        }
    };

    const addCarrier = () => {
        setCarriers(prev => [
            ...prev,
            {
                name: "",
                chargeType: "Air Freight",
                cost: "",
                currency: "USD",
                sellingCarriers: "",
                sellingCarriersRate: "USD",

                polCountry: null,
                pol: null,
                polInput: "",

                podCountry: null,
                pod: null,
                podInput: "",
            },
        ]);
    };



    const removeCarrier = (index) => {
        setCarriers(prev => prev.filter((_, i) => i !== index));
    };

    const handleExtraChange = (index, field, value) => {
        setExtraCosts(prev =>
            prev.map((e, i) => (i === index ? { ...e, [field]: value } : e))
        );
    };

    const addExtra = () => {
        setExtraCosts(prev => [
            ...prev,
            { type: "", amount: "", currency: "USD", extraSelling: "", extraSellingRate: "USD" },
        ]);
    };

    const removeExtra = (index) => {
        setExtraCosts(prev => prev.filter((_, i) => i !== index));
    };

    const renderServiceAddressFields = (
        title,
        address,
        setAddress,
        type,
        dynamicOptions = [],
        loading = false,
        servicePricing,
        setServicePricing,
        serviceTarget
    ) => {
        const providerValue =
            carrierAccountOptions.find((item) => item.name === servicePricing.serviceProvider) ||
            (servicePricing.serviceProvider
                ? {
                    id: `manual-${serviceTarget}-${servicePricing.serviceProvider}`,
                    name: servicePricing.serviceProvider,
                    type: "manual",
                }
                : null);

        return (
            <MDBox
                sx={{
                    border: "1px solid #e0e0e0",
                    borderRadius: 2,
                    p: 2,
                    height: "100%",
                    backgroundColor: "#fff",
                }}
            >
                <MDTypography variant="subtitle2" mb={2}>
                    {title}
                </MDTypography>

                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <Autocomplete
                            options={countryOptions}
                            value={countryOptions.find((c) => c.label === address.country) || null}
                            onChange={(_e, newValue) =>
                                setAddress((prev) => ({
                                    ...prev,
                                    country: newValue?.label || "",
                                    city: "",
                                    port: "",
                                    type,
                                }))
                            }
                            getOptionLabel={(option) => option?.label || ""}
                            isOptionEqualToValue={(option, value) => option?.label === value?.label}
                            renderInput={(params) => (
                                <TextField {...params} label="Country" fullWidth InputLabelProps={{ shrink: true }} />
                            )}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Autocomplete
                            options={dynamicOptions}
                            loading={loading}
                            value={type === "door" ? address.city || null : address.port || null}
                            onChange={(_e, newValue) =>
                                setAddress((prev) => ({
                                    ...prev,
                                    city: type === "door" ? newValue || "" : "",
                                    port: type === "port" ? newValue || "" : "",
                                    type,
                                }))
                            }
                            onInputChange={(_e, newValue, reason) => {
                                if (reason === "reset") return;
                                setAddress((prev) => ({
                                    ...prev,
                                    city: type === "door" ? newValue || "" : "",
                                    port: type === "port" ? newValue || "" : "",
                                    type,
                                }));
                            }}
                            freeSolo
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={type === "door" ? "City" : "Airport"}
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                />
                            )}
                        />
                    </Grid>

                    {type === "door" && (
                        <Grid item xs={12}>
                            <TextField
                                label="Full Address"
                                value={address.additionalInfo || ""}
                                onChange={(e) =>
                                    setAddress((prev) => ({ ...prev, additionalInfo: e.target.value }))
                                }
                                fullWidth
                                multiline
                                minRows={2}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                    )}

                    <Grid item xs={12}>
                        <Autocomplete
                            options={carrierAccountOptions}
                            value={providerValue}
                            onChange={(_event, newValue) => {
                                if (newValue?.type === "new") {
                                    setServiceProviderModalTargetIndex(serviceTarget);
                                    setServiceProviderModalOpen(true);
                                    return;
                                }
                                setServicePricing((prev) => ({
                                    ...prev,
                                    serviceProvider: newValue?.name || "",
                                }));
                            }}
                            getOptionLabel={(option) => option?.name || ""}
                            isOptionEqualToValue={(option, value) =>
                                option?.type === value?.type && option?.id === value?.id
                            }
                            renderOption={({ key: optionKey, ...props }, option) => (
                                <li {...props} key={`${option.type}-${option.id}`}>
                                    {option.type === "new" ? (
                                        <strong style={{ color: "#1976d2" }}>+ New Account</strong>
                                    ) : (
                                        <>
                                            {option.name}
                                            <span style={{ marginLeft: 8, opacity: 0.7, fontSize: 12 }}>
                                                {option.type === "serviceProvider"
                                                    ? "(Service Provider)"
                                                    : option.type === "customer"
                                                        ? "(Customer)"
                                                        : option.type === "agent"
                                                            ? "(Global Agent)"
                                                            : "(Manual)"}
                                            </span>
                                        </>
                                    )}
                                </li>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Service Provider"
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                />
                            )}
                        />
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <TextField
                            label="Cost"
                            type="number"
                            value={servicePricing.cost}
                            onChange={(e) =>
                                setServicePricing((prev) => ({ ...prev, cost: e.target.value }))
                            }
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>

                    <Grid item xs={12} md={2}>
                        <TextField
                            select
                            label="Cost Currency"
                            value={servicePricing.costCurrency || carriers?.[0]?.currency || "USD"}
                            onChange={(e) =>
                                setServicePricing((prev) => ({ ...prev, costCurrency: e.target.value }))
                            }
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                        >
                            {["USD", "EUR", "TRY", "GBP"].map((item) => (
                                <MenuItem key={item} value={item}>{item}</MenuItem>
                            ))}
                        </TextField>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={Boolean(servicePricing.sellingIncluded)}
                                    onChange={(e) =>
                                        setServicePricing((prev) => ({
                                            ...prev,
                                            sellingIncluded: e.target.checked,
                                            selling: e.target.checked ? "" : prev.selling,
                                        }))
                                    }
                                />
                            }
                            label="Selling Included"
                        />
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <TextField
                            label="Selling"
                            type="number"
                            value={servicePricing.sellingIncluded ? "" : servicePricing.selling}
                            disabled={Boolean(servicePricing.sellingIncluded)}
                            onChange={(e) =>
                                setServicePricing((prev) => ({ ...prev, selling: e.target.value }))
                            }
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <TextField
                            select
                            label="Selling Currency"
                            value={servicePricing.sellingCurrency || carriers?.[0]?.sellingCarriersRate || "USD"}
                            disabled={Boolean(servicePricing.sellingIncluded)}
                            onChange={(e) =>
                                setServicePricing((prev) => ({ ...prev, sellingCurrency: e.target.value }))
                            }
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                        >
                            {["USD", "EUR", "TRY", "GBP"].map((item) => (
                                <MenuItem key={item} value={item}>{item}</MenuItem>
                            ))}
                        </TextField>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <TextField
                            label="Remarks"
                            value={servicePricing.remarks || ""}
                            onChange={(e) =>
                                setServicePricing((prev) => ({ ...prev, remarks: e.target.value }))
                            }
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                </Grid>
            </MDBox>
        );
    };

    useEffect(() => {
        if (!exchangeRates) return;

        const hasPickup = serviceLayout.pickup.length > 0;
        const hasDelivery = serviceLayout.delivery.length > 0;

        const carrierBuying = carriers.reduce((sum, c) =>
            sum + convertAmount(Number(c.cost || 0), c.currency, baseCurrency), 0);

        const extraBuying = extraCosts.reduce((sum, e) =>
            sum + convertAmount(Number(e.amount || 0), e.currency, baseCurrency), 0);

        const pickupBuying = hasPickup
            ? convertAmount(Number(pickupService.cost || 0), pickupService.costCurrency, baseCurrency)
            : 0;

        const deliveryBuying = hasDelivery
            ? convertAmount(Number(deliveryService.cost || 0), deliveryService.costCurrency, baseCurrency)
            : 0;

        setTotalBuying(carrierBuying + extraBuying + pickupBuying + deliveryBuying);
        setTotalExtraBuying(extraBuying);

        const carrierSelling = carriers.reduce((sum, c) =>
            sum + convertAmount(Number(c.sellingCarriers || 0), c.sellingCarriersRate, baseCurrency), 0);

        const extraSelling = extraCosts.reduce((sum, e) =>
            sum + convertAmount(Number(e.extraSelling || 0), e.extraSellingRate, baseCurrency), 0);

        const pickupSelling = hasPickup && !pickupService.sellingIncluded
            ? convertAmount(Number(pickupService.selling || 0), pickupService.sellingCurrency, baseCurrency)
            : 0;

        const deliverySelling = hasDelivery && !deliveryService.sellingIncluded
            ? convertAmount(Number(deliveryService.selling || 0), deliveryService.sellingCurrency, baseCurrency)
            : 0;

        setTotalCarrierSelling(carrierSelling + pickupSelling + deliverySelling);
        setTotalExtraSelling(extraSelling);
    }, [
        carriers,
        extraCosts,
        pickupService,
        deliveryService,
        serviceLayout,
        baseCurrency,
        exchangeRates,
    ]);


    const toNum = (v) => {
        const n = Number(v);
        return Number.isFinite(n) ? n : 0;
    };

    const breakdownSellingTotal = toNum(totalCarrierSelling) + toNum(totalExtraSelling);
    const hasAnySellingInput = React.useMemo(() => {
        const hasCarrier = (carriers || []).some((c) => Number(c?.sellingCarriers) > 0);
        const hasExtra = (extraCosts || []).some((e) => Number(e?.extraSelling) > 0);
        const hasPickup = serviceLayout.pickup.length > 0 &&
            (pickupService.sellingIncluded || Number(pickupService.selling) > 0);
        const hasDelivery = serviceLayout.delivery.length > 0 &&
            (deliveryService.sellingIncluded || Number(deliveryService.selling) > 0);
        return hasCarrier || hasExtra || hasPickup || hasDelivery;
    }, [carriers, extraCosts, pickupService, deliveryService, serviceLayout]);
    const useLineSelling = airPricingMode === "BREAKDOWN" || hasAnySellingInput;

    const sellingCalc = React.useMemo(() => {
        const buying = toNum(totalBuying);

        if (useLineSelling) {
            const finalSelling = toNum(breakdownSellingTotal);
            const marginUnit = finalSelling - buying;
            const marginPercent = buying > 0 ? (marginUnit / buying) * 100 : 0;

            return {
                finalSelling,
                finalMarginUnit: Number.isFinite(marginUnit) ? marginUnit : 0,
                finalMarginPercent: Number.isFinite(marginPercent) ? marginPercent : 0,
            };
        }

        const pct = Number(marginPercentInput);
        const unit = Number(marginUnitInput);
        const manual = Number(sellingRateInput);

        let finalSelling = buying;
        let finalMarginUnit = 0;
        let finalMarginPercent = 0;

        if (sellingDriver === "PERCENT" && marginPercentInput !== "" && !Number.isNaN(pct)) {
            finalMarginPercent = pct;
            finalMarginUnit = (buying * pct) / 100;
            finalSelling = buying + finalMarginUnit;
        } else if (sellingDriver === "UNIT" && marginUnitInput !== "" && !Number.isNaN(unit)) {
            finalMarginUnit = unit;
            finalMarginPercent = buying > 0 ? (unit / buying) * 100 : 0;
            finalSelling = buying + unit;
        } else if (sellingDriver === "SELLING" && sellingRateInput !== "" && !Number.isNaN(manual)) {
            finalSelling = manual;
            finalMarginUnit = manual - buying;
            finalMarginPercent = buying > 0 ? (finalMarginUnit / buying) * 100 : 0;
        }

        return {
            finalSelling,
            finalMarginUnit: Number.isFinite(finalMarginUnit) ? finalMarginUnit : 0,
            finalMarginPercent: Number.isFinite(finalMarginPercent) ? finalMarginPercent : 0,
        };
    }, [
        useLineSelling,
        sellingDriver,
        marginPercentInput,
        marginUnitInput,
        sellingRateInput,
        totalBuying,
        breakdownSellingTotal,
    ]);


    useEffect(() => {
        if (hydratingFromDb) return;
        if (useLineSelling) return;

        const buying = toNum(totalBuying);
        if (!Number.isFinite(buying)) return;

        const safeSet = (setter, next) => {
            const n = next == null ? "" : String(next);
            setter((prev) => (String(prev) === n ? prev : n));
        };

        const source = activeSellingField || sellingDriver;

        if (source === "PERCENT") {
            if (marginPercentInput === "") return;
            const pct = Number(marginPercentInput);
            if (Number.isNaN(pct)) return;

            const unit = (buying * pct) / 100;
            safeSet(setMarginUnitInput, unit.toFixed(2));
            safeSet(setSellingRateInput, (buying + unit).toFixed(2));
            return;
        }

        if (source === "UNIT") {
            if (marginUnitInput === "") return;
            const unit = Number(marginUnitInput);
            if (Number.isNaN(unit)) return;

            const pct = buying > 0 ? (unit / buying) * 100 : 0;
            safeSet(setMarginPercentInput, pct.toFixed(2));
            safeSet(setSellingRateInput, (buying + unit).toFixed(2));
            return;
        }

        if (source === "SELLING") {
            if (sellingRateInput === "") return;
            const manual = Number(sellingRateInput);
            if (Number.isNaN(manual)) return;

            const unit = manual - buying;
            const pct = buying > 0 ? (unit / buying) * 100 : 0;
            safeSet(setMarginUnitInput, unit.toFixed(2));
            safeSet(setMarginPercentInput, pct.toFixed(2));
        }
    }, [
        hydratingFromDb,
        useLineSelling,
        totalBuying,
        activeSellingField,
        sellingDriver,
        marginPercentInput,
        marginUnitInput,
        sellingRateInput,
    ]);

    useEffect(() => {
        if (hydratingFromDb) return;
        if (!useLineSelling) return;
        if (activeSellingField) return;

        const buying = toNum(totalBuying);
        const selling = toNum(breakdownSellingTotal);

        const unit = selling - buying;
        const pct = buying > 0 ? (unit / buying) * 100 : 0;

        const safeSet = (setter, next) => {
            const v = next == null ? "" : String(next);
            setter((prev) => (String(prev) === v ? prev : v));
        };

        safeSet(setSellingRateInput, selling.toFixed(2));
        safeSet(setMarginUnitInput, unit.toFixed(2));
        safeSet(setMarginPercentInput, pct.toFixed(2));

        setSellingDriver("SELLING");
    }, [
        hydratingFromDb,
        useLineSelling,
        activeSellingField,
        breakdownSellingTotal,
        totalBuying,
    ]);



    useEffect(() => {
        carriers.forEach((c, i) => {
            if (c.polCountry && c.pol && !carrierAirportOptions[i]) {
                searchAirports({
                    query: c.pol,
                    country: c.polCountry.label,
                    setter: (opts) =>
                        setCarrierAirportOptions(prev => ({
                            ...prev,
                            [i]: opts,
                        })),
                    setLoading: () => {},
                    key: `init-pol-${i}`,
                });
            }

            if (c.podCountry && c.pod && !carrierAirportOptions[`pod-${i}`]) {
                searchAirports({
                    query: c.pod,
                    country: c.podCountry.label,
                    setter: (opts) =>
                        setCarrierAirportOptions(prev => ({
                            ...prev,
                            [`pod-${i}`]: opts,
                        })),
                    setLoading: () => {},
                    key: `init-pod-${i}`,
                });
            }
        });
    }, [carriers]);

    useEffect(() => {
        if (isEditing && selectedCustomer) {
            setInputValue(selectedCustomer.name);
            setOpen(false);
        }
    }, [isEditing, selectedCustomer]);

    const pickOptionByLabel = (opts, label) => {
        const t = String(label || "").trim().toLowerCase();
        return (opts || []).find(o => String(o?.label || "").trim().toLowerCase() === t) || null;
    };

    useEffect(() => {
        setCarriers(prev =>
            (prev || []).map((c, i) => {
                const polOpts = carrierAirportOptions[i] || [];
                const podOpts = carrierAirportOptions[`pod-${i}`] || [];

                const next = { ...c };

                // POL sync
                if (c.polCountry?.label && c.polInput && !c.pol) {
                    const found = pickOptionByLabel(polOpts, c.polInput);
                    if (found) next.pol = found;
                }

                // POD sync
                if (c.podCountry?.label && c.podInput && !c.pod) {
                    const found = pickOptionByLabel(podOpts, c.podInput);
                    if (found) next.pod = found;
                }

                return next;
            })
        );
    }, [carrierAirportOptions]);


    const hasPickupService = React.useMemo(
        () => Array.isArray(serviceLayout?.pickup) && serviceLayout.pickup.length > 0,
        [serviceLayout]
    );

    const hasDeliveryService = React.useMemo(
        () => Array.isArray(serviceLayout?.delivery) && serviceLayout.delivery.length > 0,
        [serviceLayout]
    );

    const summaryBuyingCurrency =
        carriers?.[0]?.currency ||
        baseCurrency ||
        "USD";

    const summarySellingCurrency =
        carriers?.[0]?.sellingCarriersRate ||
        baseCurrency ||
        "USD";

    const safeConvertAmount = React.useCallback(
        (amount, fromCurrency, toCurrency) => {
            const numericAmount = Number(amount || 0);

            if (!Number.isFinite(numericAmount)) {
                return 0;
            }

            const from = String(
                fromCurrency || toCurrency || "USD"
            ).toUpperCase();

            const to = String(
                toCurrency || fromCurrency || "USD"
            ).toUpperCase();

            if (from === to) {
                return numericAmount;
            }

            if (!exchangeRates) {
                return numericAmount;
            }

            const fromRate =
                from === "USD"
                    ? 1
                    : Number(exchangeRates[from]);

            const toRate =
                to === "USD"
                    ? 1
                    : Number(exchangeRates[to]);

            if (
                !Number.isFinite(fromRate) ||
                fromRate <= 0 ||
                !Number.isFinite(toRate) ||
                toRate <= 0
            ) {
                return numericAmount;
            }

            const amountInUsd =
                numericAmount / fromRate;

            return amountInUsd * toRate;
        },
        [exchangeRates]
    );

    const formatSummaryAmount = React.useCallback(
        (amount) => {
            const numericAmount = Number(amount || 0);

            return numericAmount.toLocaleString("en-US", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            });
        },
        []
    );

    const carrierBuyingRows = React.useMemo(
        () =>
            (carriers || []).map((carrierItem, index) => ({
                key: `carrier-buying-${index}`,
                label:
                    carrierItem.chargeType ||
                    `Air Freight Cost #${index + 1}`,
                amount: safeConvertAmount(
                    carrierItem.cost,
                    carrierItem.currency || summaryBuyingCurrency,
                    summaryBuyingCurrency
                ),
            })),
        [
            carriers,
            safeConvertAmount,
            summaryBuyingCurrency,
        ]
    );

    const extraBuyingRows = React.useMemo(
        () =>
            (extraCosts || []).map((extraItem, index) => ({
                key: `extra-buying-${index}`,
                label: extraItem.type
                    ? `Extra Cost - ${extraItem.type}`
                    : `Extra Cost #${index + 1}`,
                amount: safeConvertAmount(
                    extraItem.amount,
                    extraItem.currency || summaryBuyingCurrency,
                    summaryBuyingCurrency
                ),
            })),
        [
            extraCosts,
            safeConvertAmount,
            summaryBuyingCurrency,
        ]
    );

    const pickupCostForSummary = React.useMemo(() => {
        if (!hasPickupService) {
            return 0;
        }

        return safeConvertAmount(
            pickupService?.cost,
            pickupService?.costCurrency || summaryBuyingCurrency,
            summaryBuyingCurrency
        );
    }, [
        hasPickupService,
        pickupService,
        safeConvertAmount,
        summaryBuyingCurrency,
    ]);

    const deliveryCostForSummary = React.useMemo(() => {
        if (!hasDeliveryService) {
            return 0;
        }

        return safeConvertAmount(
            deliveryService?.cost,
            deliveryService?.costCurrency || summaryBuyingCurrency,
            summaryBuyingCurrency
        );
    }, [
        hasDeliveryService,
        deliveryService,
        safeConvertAmount,
        summaryBuyingCurrency,
    ]);

    const carrierSellingForSummary = React.useMemo(
        () =>
            (carriers || []).reduce(
                (total, carrierItem) =>
                    total +
                    safeConvertAmount(
                        carrierItem.sellingCarriers,
                        carrierItem.sellingCarriersRate ||
                        summarySellingCurrency,
                        summarySellingCurrency
                    ),
                0
            ),
        [
            carriers,
            safeConvertAmount,
            summarySellingCurrency,
        ]
    );

    const pickupSellingForSummary = React.useMemo(() => {
        if (
            !hasPickupService ||
            pickupService?.sellingIncluded
        ) {
            return 0;
        }

        return safeConvertAmount(
            pickupService?.selling,
            pickupService?.sellingCurrency ||
            summarySellingCurrency,
            summarySellingCurrency
        );
    }, [
        hasPickupService,
        pickupService,
        safeConvertAmount,
        summarySellingCurrency,
    ]);

    const deliverySellingForSummary = React.useMemo(() => {
        if (
            !hasDeliveryService ||
            deliveryService?.sellingIncluded
        ) {
            return 0;
        }

        return safeConvertAmount(
            deliveryService?.selling,
            deliveryService?.sellingCurrency ||
            summarySellingCurrency,
            summarySellingCurrency
        );
    }, [
        hasDeliveryService,
        deliveryService,
        safeConvertAmount,
        summarySellingCurrency,
    ]);

    /*
     * Pickup ve Delivery selling ayrı satır olarak gösterilmez.
     * Air Freight Selling tutarının içinde birleştirilir.
     */
    const combinedAirFreightSelling =
        Number(carrierSellingForSummary || 0) +
        Number(pickupSellingForSummary || 0) +
        Number(deliverySellingForSummary || 0);

    const extraSellingRows = React.useMemo(
        () =>
            (extraCosts || []).map((extraItem, index) => ({
                key: `extra-selling-${index}`,
                label: extraItem.type
                    ? `Extra Selling - ${extraItem.type}`
                    : `Extra Selling #${index + 1}`,
                amount: safeConvertAmount(
                    extraItem.extraSelling,
                    extraItem.extraSellingRate ||
                    summarySellingCurrency,
                    summarySellingCurrency
                ),
            })),
        [
            extraCosts,
            safeConvertAmount,
            summarySellingCurrency,
        ]
    );

    const summaryTotalBuying = React.useMemo(() => {
        const carrierBuyingTotal =
            carrierBuyingRows.reduce(
                (total, row) =>
                    total + Number(row.amount || 0),
                0
            );

        const extraBuyingTotal =
            extraBuyingRows.reduce(
                (total, row) =>
                    total + Number(row.amount || 0),
                0
            );

        return (
            carrierBuyingTotal +
            extraBuyingTotal +
            Number(pickupCostForSummary || 0) +
            Number(deliveryCostForSummary || 0)
        );
    }, [
        carrierBuyingRows,
        extraBuyingRows,
        pickupCostForSummary,
        deliveryCostForSummary,
    ]);

    const summaryTotalSelling = React.useMemo(() => {
        const extraSellingTotal =
            extraSellingRows.reduce(
                (total, row) =>
                    total + Number(row.amount || 0),
                0
            );

        return (
            Number(combinedAirFreightSelling || 0) +
            extraSellingTotal
        );
    }, [
        combinedAirFreightSelling,
        extraSellingRows,
    ]);

    return (
        <Grid container spacing={0} justifyContent="center" mt={1} mb={1}>
            <Grid item xs={12} lg={10}> {/* Daha geniş olması için lg={10} veya 12 kullanabilirsin */}
                <MDBox mb={2}>
                    <Grid container justifyContent="center">
                        <Grid item xs={12} lg={12}>
                            <MDBox mb={1} textAlign="center">
                                <div
                                    ref={successMessageRef} // Ref burada tanımlandı
                                    style={{
                                        backgroundColor: successMessage ? "#7edd82" : errorMessage ? "#e57373" : "transparent",
                                        color: successMessage || errorMessage ? "#FFFFFF" : "transparent",
                                        padding: "10px",
                                        textAlign: "center",
                                        marginBottom: "10px",
                                        borderRadius: "5px",
                                        visibility: successMessage || errorMessage ? "visible" : "hidden", // Mesaj yoksa görünmez
                                    }}
                                >
                                    {successMessage || errorMessage}
                                </div>
                                {isEditing && editDataLoaded && savedPricingNotice(savedRecordRef.current, sellingCalc.finalSelling) && (
                                    <div
                                        style={{
                                            backgroundColor: "#fff3cd",
                                            color: "#664d03",
                                            padding: "10px",
                                            textAlign: "center",
                                            marginBottom: "10px",
                                            borderRadius: "5px",
                                        }}
                                    >
                                        {savedPricingNotice(savedRecordRef.current, sellingCalc.finalSelling)}
                                    </div>
                                )}
                                <MDBox mb={1}>
                                    <MDTypography variant="h3" fontWeight="bold">
                                        {isEditing
                                            ? " Edit Air Quote Details"
                                            : " Add Air Quote Details"}
                                    </MDTypography>
                                </MDBox>
                                <MDTypography variant="h5" fontWeight="regular" color="secondary">
                                    This information will give you more information about the Quote for Air. </MDTypography>
                            </MDBox>
                        </Grid>
                    </Grid>
                </MDBox>
                <MDBox mt={3}
                       sx={{
                           p: 3,
                           borderRadius: "10px",
                           bgcolor: "background.paper",
                           boxShadow: "none",
                       }}>

                    <MDBox mb={12}>
                        <Grid container justifyContent="center">
                            <Grid item xs={12} lg={12}>
                                <MDBox>
                                    <MDBox>
                                        <Grid container spacing={3} alignItems="center">
                                            <Grid item xs={6}>
                                                <MDTypography variant="h6" component="div">
                                                    Quote - Air {quoteNo}
                                                </MDTypography>
                                            </Grid>
                                        </Grid>
                                    </MDBox>
                                    <Box
                                        mt={3}
                                        display="flex"
                                        justifyContent="flex-start"
                                        alignItems="center"
                                        gap={4}
                                    >
                                        {/* Import Switch */}
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={quoteType === "Import"}
                                                    onChange={() => handleSwitchChangeQuotingType("Import")}
                                                    name="importSwitch"
                                                    sx={{
                                                        "& .MuiSwitch-thumb": {
                                                            backgroundColor: quoteType === "Import" ? "orange" : "white", // Açık: turuncu, Kapalı: beyaz
                                                        },
                                                        "& .MuiSwitch-track": {
                                                            backgroundColor: quoteType === "Import" ? "orange" : "white", // Açık: turuncu, Kapalı: beyaz
                                                        },
                                                    }}
                                                />
                                            }
                                            label="Import"
                                            sx={{color: "gray"}}
                                        />

                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={quoteType === "Export"}
                                                    onChange={() => handleSwitchChangeQuotingType("Export")}
                                                    name="exportSwitch"
                                                    sx={{
                                                        "& .MuiSwitch-thumb": {
                                                            backgroundColor: quoteType === "Export" ? "orange" : "white", // Açık: turuncu, Kapalı: beyaz
                                                        },
                                                        "& .MuiSwitch-track": {
                                                            backgroundColor: quoteType === "Export" ? "orange" : "white", // Açık: turuncu, Kapalı: beyaz
                                                        },
                                                    }}
                                                />
                                            }
                                            label="Export"
                                            sx={{color: "gray"}}
                                        />
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={quoteType === "Domestic"}
                                                    onChange={() => handleSwitchChangeQuotingType("Domestic")}
                                                    name="transitSwitch"
                                                    sx={{
                                                        "& .MuiSwitch-thumb": {
                                                            backgroundColor: quoteType === "Domestic" ? "orange" : "white", // Açık: turuncu, Kapalı: beyaz
                                                        },
                                                        "& .MuiSwitch-track": {
                                                            backgroundColor: quoteType === "Domestic" ? "orange" : "white", // Açık: turuncu, Kapalı: beyaz
                                                        },
                                                    }}
                                                />
                                            }
                                            label="Domestic"
                                            sx={{color: "gray"}}
                                        />
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={quoteType === "Transit"}
                                                    onChange={() => handleSwitchChangeQuotingType("Transit")}
                                                    name="transitSwitch"
                                                    sx={{
                                                        "& .MuiSwitch-thumb": {
                                                            backgroundColor: quoteType === "Transit" ? "orange" : "white", // Açık: turuncu, Kapalı: beyaz
                                                        },
                                                        "& .MuiSwitch-track": {
                                                            backgroundColor: quoteType === "Transit" ? "orange" : "white", // Açık: turuncu, Kapalı: beyaz
                                                        },
                                                    }}
                                                />
                                            }
                                            label="Transit"
                                            sx={{color: "gray"}}
                                        />
                                    </Box>
                                    <MDBox mt={3}>
                                        <Grid container spacing={1} alignItems="center">

                                            <Grid item xs={12} sm={1}>
                                                <TextField
                                                    type="text"
                                                    label="Quote No"
                                                    value={quoteNo}
                                                    placeholder="Auto-generated"
                                                    disabled
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (value === "" || Number(value) >= 0) setQuoteNo(value);
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={1}>
                                                <TextField
                                                    type="text"
                                                    label="Transport Type"
                                                    value={selectedTransportType}
                                                    disabled
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={2}>
                                                <LocalizationProvider dateAdapter={AdapterDateFns} locale={tr}>
                                                    <DatePicker
                                                        label="Quote Date"
                                                        value={quoteDate}
                                                        onChange={(newValue) => setQuoteDate(newValue)}
                                                        format="dd/MM/yyyy"
                                                        slotProps={{
                                                            textField: {
                                                                fullWidth: true,
                                                                variant: "outlined",
                                                                InputLabelProps: { shrink: true },
                                                                sx: { "& .MuiInputBase-root": { height: 40 } }
                                                            }
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>
                                        </Grid>
                                    </MDBox>


                                    <MDBox mt={3}>
                                        <Grid container spacing={3} alignItems="center">

                                            {/* Customer */}
                                            <Grid item xs={12} sm={4}>
                                                <Autocomplete
                                                    value={selectedCustomer}
                                                    onChange={(event, newValue) => {
                                                        if (newValue?.type === "new") {
                                                            setCustomerModalTarget("customer");
                                                            setCustomerModalOpen(true);
                                                            return;
                                                        }

                                                        setSelectedCustomer(newValue);
                                                        setOpen(false);
                                                    }}
                                                    inputValue={inputValue}
                                                    onInputChange={(event, newInputValue) => {
                                                        setInputValue(newInputValue);
                                                        setOpen(newInputValue.length > 0);
                                                    }}
                                                    options={[
                                                        NEW_PARTY_OPTION,
                                                        ...partyOptions,
                                                        // listede olmayan (silinmiş / adı değişmiş) kayıtlı müşteri de seçili görünsün
                                                        ...(selectedCustomer?.name && !partyOptions.some((o) => o.name === selectedCustomer.name) ? [selectedCustomer] : []),
                                                    ]}
                                                    getOptionLabel={(option) => option?.name || ""}
                                                    filterOptions={(options, state) =>
                                                        options.filter((option) =>
                                                            (option.name || "").toLowerCase().includes(state.inputValue.toLowerCase())
                                                        )
                                                    }
                                                    renderOption={({ key: optionKey, ...props }, option) => (
                                                        <li {...props} key={`${option.type}-${option.id}`}>
                                                            {option.type === "new" ? (
                                                                <strong style={{ color: "#1976d2" }}>
                                                                    + New Account
                                                                </strong>
                                                            ) : (
                                                                <>
                                                                    {option.name}
                                                                    <span
                                                                        style={{
                                                                            marginLeft: 8,
                                                                            opacity: 0.7,
                                                                            fontSize: 12,
                                                                        }}
                                                                    >
                                                                            {option.type === "customer"
                                                                                ? "(Customer)"
                                                                                : "(Global Agent)"}
                                                                        </span>
                                                                </>
                                                            )}
                                                        </li>
                                                    )}
                                                    open={open}
                                                    onClose={() => setOpen(false)}
                                                    onFocus={() => {
                                                        if (!isEditing) setOpen(true);
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Search Customer / Global Agent"
                                                            variant="outlined"
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{
                                                                "& .MuiInputBase-root": { height: 50 },
                                                            }}
                                                            InputProps={{
                                                                ...params.InputProps,
                                                            }}
                                                        />
                                                    )}
                                                />

                                            </Grid>

                                            {/* Shipper */}
                                            <Grid item xs={12} sm={4}>
                                                <Autocomplete
                                                    options={[NEW_PARTY_OPTION, ...shipperConsigneeOptions]}
                                                    value={findOptionByName(shipper)}
                                                    onChange={(event, newValue) => {
                                                        if (newValue?.type === "new") {
                                                            setCustomerModalTarget("shipper");
                                                            setCustomerModalOpen(true);
                                                            return;
                                                        }

                                                        setShipper(newValue?.name || "");
                                                    }}
                                                    getOptionLabel={(option) => option?.name || ""}
                                                    isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
                                                    renderOption={({ key: optionKey, ...props }, option) => (
                                                        <li {...props} key={option.id}>
                                                            {option.type === "new" ? (
                                                                <strong style={{ color: "#1976d2" }}>+ New Account</strong>
                                                            ) : (
                                                                <>
                                                                    {option.name}
                                                                    <span style={{ marginLeft: 8, opacity: 0.7, fontSize: 12 }}>
                                                                  {option.type === "customer"
                                                                      ? "(Customer)"
                                                                      : option.type === "agent"
                                                                          ? "(Global Agent)"
                                                                          : "(Company)"}
                                                                </span>
                                                                </>
                                                            )}
                                                        </li>
                                                    )}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Shipper"
                                                            variant="outlined"
                                                            fullWidth
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{ "& .MuiInputBase-root": { height: 50 } }}
                                                        />
                                                    )}
                                                />
                                            </Grid>

                                            {/* Consignee */}
                                            <Grid item xs={12} sm={4}>
                                                <Autocomplete
                                                    options={[NEW_PARTY_OPTION, ...shipperConsigneeOptions]}
                                                    value={findOptionByName(consignee)}
                                                    onChange={(event, newValue) => {
                                                        if (newValue?.type === "new") {
                                                            setCustomerModalTarget("consignee");
                                                            setCustomerModalOpen(true);
                                                            return;
                                                        }

                                                        setConsignee(newValue?.name || "");
                                                    }}
                                                    getOptionLabel={(option) => option?.name || ""}
                                                    isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
                                                    renderOption={({ key: optionKey, ...props }, option) => (
                                                        <li {...props} key={option.id}>
                                                            {option.type === "new" ? (
                                                                <strong style={{ color: "#1976d2" }}>+ New Account</strong>
                                                            ) : (
                                                                <>
                                                                    {option.name}
                                                                    <span style={{ marginLeft: 8, opacity: 0.7, fontSize: 12 }}>
              {option.type === "customer"
                  ? "(Customer)"
                  : option.type === "agent"
                      ? "(Global Agent)"
                      : "(Company)"}
            </span>
                                                                </>
                                                            )}
                                                        </li>
                                                    )}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Consignee"
                                                            variant="outlined"
                                                            fullWidth
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{ "& .MuiInputBase-root": { height: 50 } }}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>
                                    </MDBox>

                                    <MDBox mt={3}>
                                        <MDTypography variant="h6" mb={1}>
                                            Cargo Details
                                        </MDTypography>
                                        <Grid container spacing={3}>
                                            {/* Commodity */}
                                            <Grid item xs={12} sm={2}>
                                                <TextField
                                                    type="text"
                                                    label="Commodity"
                                                    value={commodity}
                                                    onChange={(e) => setCommodity(e.target.value)}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    fullWidth
                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                />
                                            </Grid>
                                            {/* Quantity */}
                                            <Grid item xs={12} sm={1}>
                                                <TextField
                                                    type="number"
                                                    label="Quantity"
                                                    value={quantity}
                                                    onChange={handleInputChange(setQuantity)}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    fullWidth
                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={2}>
                                                <TextField
                                                    select
                                                    label="Unit"
                                                    value={dimensionUnit}
                                                    onChange={(e) => setDimensionUnit(e.target.value)}
                                                    fullWidth
                                                    InputLabelProps={{ shrink: true }}
                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                >
                                                    {dimensionUnitOptions.map((unit) => (
                                                        <MenuItem key={unit} value={unit}>
                                                            {unit}
                                                        </MenuItem>
                                                    ))}
                                                </TextField>
                                            </Grid>

                                            {/* Width */}
                                            <Grid item xs={12} sm={2}>
                                                <TextField
                                                    type="number"
                                                    label={`Width (${dimensionUnit})`}
                                                    value={width}
                                                    onChange={handleInputChange(setWidth)}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    fullWidth
                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                />
                                            </Grid>

                                            {/* Length */}
                                            <Grid item xs={12} sm={2}>
                                                <TextField
                                                    type="number"
                                                    label={`Length (${dimensionUnit})`}
                                                    value={length}
                                                    onChange={handleInputChange(setLength)}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    fullWidth
                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                />
                                            </Grid>

                                            {/* Height */}
                                            <Grid item xs={12} sm={2}>
                                                <TextField
                                                    type="number"
                                                    label={`Height (${dimensionUnit})`}
                                                    value={height}
                                                    onChange={handleInputChange(setHeight)}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    fullWidth
                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                />
                                            </Grid>

                                            {/* Volume */}
                                            <Grid item xs={12} sm={1}>
                                                <TextField
                                                    type="number"
                                                    label="Volume"
                                                    value={volume}
                                                    onChange={(e) => setVolume(e.target.value)}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    fullWidth
                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                />
                                            </Grid>

                                            {/* Gross Weight */}
                                            <Grid item xs={12} sm={2}>
                                                <TextField
                                                    type="number"
                                                    label="Gross Weight (kg)"
                                                    value={grossWeight}
                                                    onChange={(e) => setGrossWeight(e.target.value)}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    fullWidth
                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={2}>
                                                <TextField
                                                    type="number"
                                                    label="Chargable Weight (kg)"
                                                    value={chargeableWeight}
                                                    onChange={(e) => setChargeableWeight(e.target.value)}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    fullWidth
                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                />
                                            </Grid>

                                        </Grid>

                                        {/* Special Handling */}
                                        <Grid container spacing={3} mt={1}>
                                            <Grid item xs={12}>
                                                <TextField
                                                    type="text"
                                                    label="Special Handling"
                                                    value={specialHandling}
                                                    onChange={(e) => setSpecialHandling(e.target.value)}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    fullWidth
                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </MDBox>


                                    <MDBox mt={3}>
                                        <MDTypography variant="h6" mb={1}>
                                            Service Details
                                        </MDTypography>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} sm={3}>
                                                <LocalizationProvider dateAdapter={AdapterDateFns} locale={tr}>
                                                    <DatePicker
                                                        label="Estimated Close Date"
                                                        value={estimatedCloseDate}
                                                        onChange={(newValue) => setEstimatedCloseDate(newValue)}
                                                        format="dd/MM/yyyy"
                                                        slotProps={{
                                                            textField: {
                                                                fullWidth: true,
                                                                variant: "outlined",
                                                                InputLabelProps: { shrink: true },
                                                                sx: { "& .MuiInputBase-root": { height: 40 } }
                                                            }
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>

                                            <Grid item xs={12} sm={3}>
                                                <TextField
                                                    type="text"
                                                    label="Transit Time (Days)"
                                                    value={transitTime}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                    onChange={(e) => {
                                                        const v = e.target.value;
                                                        if (v === "" || Number(v) >= 0) setTransitTime(v);
                                                    }}
                                                    fullWidth
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={3}>
                                                <TextField
                                                    type="text"
                                                    label="Origin Free Time (Hours)"
                                                    value={originFreeTime}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                    onChange={(e) => {
                                                        const v = e.target.value;
                                                        if (v === "" || Number(v) >= 0) setOriginFreeTime(v);
                                                    }}
                                                    fullWidth
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={3}>
                                                <TextField
                                                    type="text"
                                                    label="Destination Free Time (Hours)"
                                                    value={destinationFreeTime}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                    onChange={(e) => {
                                                        const v = e.target.value;
                                                        if (v === "" || Number(v) >= 0) setDestinationFreeTime(v);
                                                    }}
                                                    fullWidth
                                                />
                                            </Grid>
                                            {/* Service Level */}
                                            <Grid item xs={12} sm={4}>
                                                <Autocomplete
                                                    options={serviceOptions}
                                                    getOptionLabel={(option) => option.label}
                                                    value={selectedService ? { label: selectedService } : null}
                                                    onChange={(event, newValue) =>
                                                        setSelectedService(newValue ? newValue.label : "")
                                                    }
                                                    isOptionEqualToValue={(option, value) => option.label === value.label}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Service Level"
                                                            variant="outlined"
                                                            InputLabelProps={{ shrink: true }}
                                                            fullWidth
                                                            sx={{
                                                                "& .MuiInputBase-root": { height: 50 }}}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            {/* Sales Representatives */}
                                            <Grid item xs={12} sm={4}>
                                                <Autocomplete
                                                    multiple
                                                    options={salesRepOptions}
                                                    getOptionLabel={(option) => option.label}
                                                    value={salesRep}
                                                    onChange={(event, newValues) => setSalesRep(newValues)}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Sales Representatives"
                                                            variant="outlined"
                                                            InputLabelProps={{ shrink: true }}
                                                            fullWidth
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            {/* Incoterm */}
                                            <Grid item xs={12} sm={4}>
                                                <Autocomplete
                                                    options={incotermsOptions}
                                                    getOptionLabel={(option) => option.label}
                                                    value={selectedIncoterm ? { label: selectedIncoterm } : null}
                                                    onChange={(e, v) => setSelectedIncoterm(v ? v.label : "")}
                                                    isOptionEqualToValue={(o, v) => o.label === v.label}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Incoterm"
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>
                                    </MDBox>
                                    <br/>
                                    {selectedService && (
                                        <MDBox mt={3}>
                                            <MDTypography variant="h6" fontWeight="bold" mb={2}>
                                                Pickup & Delivery Details
                                            </MDTypography>

                                            <Grid container spacing={2}>
                                                {serviceLayout.pickup.map((item) => (
                                                    <Grid item xs={12} md={6} key={item.key}>
                                                        {renderServiceAddressFields(
                                                            item.label,
                                                            pickupAddress1,
                                                            setPickupAddress1,
                                                            item.type,
                                                            pickupAddress1Options,
                                                            pickupAddress1Loading,
                                                            pickupService,
                                                            setPickupService,
                                                            "pickup"
                                                        )}
                                                    </Grid>
                                                ))}

                                                {serviceLayout.delivery.map((item) => (
                                                    <Grid item xs={12} md={6} key={item.key}>
                                                        {renderServiceAddressFields(
                                                            item.label,
                                                            deliveryAddress2,
                                                            setDeliveryAddress2,
                                                            item.type,
                                                            deliveryAddress2Options,
                                                            deliveryAddress2Loading,
                                                            deliveryService,
                                                            setDeliveryService,
                                                            "delivery"
                                                        )}
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        </MDBox>
                                    )}

                                    <Grid item xs={12}>

                                        <MDBox mt={3} display="flex" gap={4}>
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        checked={airPricingMode === "ALL_IN"}
                                                        onChange={() => setAirPricingMode("ALL_IN")}
                                                    />
                                                }
                                                label="All-in"
                                            />

                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        checked={airPricingMode === "BREAKDOWN"}
                                                        onChange={() => setAirPricingMode("BREAKDOWN")}
                                                    />
                                                }
                                                label="Breakdown"
                                            />
                                        </MDBox>


                                        {/* ===================== CARRIERS ===================== */}
                                        <MDTypography variant="h6" mb={1}>
                                            Carriers & Air Freight Costs
                                        </MDTypography>

                                        {carriers.map((row, index) => (
                                            <Grid container spacing={2} alignItems="center" mb={2} key={index}>
                                                <Grid item xs={3}>
                                                    <Autocomplete
                                                        options={carrierAccountOptions}
                                                        value={
                                                            carrierAccountOptions.find((x) => x.name === row.name) ||
                                                            (row.name
                                                                ? {
                                                                    id: `manual-${row.name}`,
                                                                    name: row.name,
                                                                    type: "manual",
                                                                }
                                                                : null)
                                                        }
                                                        onChange={(_, newValue) => {
                                                            if (newValue?.type === "new") {
                                                                setServiceProviderModalTargetIndex(index);
                                                                setServiceProviderModalOpen(true);
                                                                return;
                                                            }

                                                            handleCarrierChange(index, "name", newValue?.name || "");
                                                        }}
                                                        getOptionLabel={(option) => option?.name || ""}
                                                        isOptionEqualToValue={(option, value) =>
                                                            option?.type === value?.type && option?.id === value?.id
                                                        }
                                                        renderOption={({ key: optionKey, ...props }, option) => (
                                                            <li {...props} key={`${option.type}-${option.id}`}>
                                                                {option.type === "new" ? (
                                                                    <strong style={{ color: "#1976d2" }}>
                                                                        + New Account
                                                                    </strong>
                                                                ) : (
                                                                    <>
                                                                        {option.name}
                                                                        <span style={{ marginLeft: 8, opacity: 0.7, fontSize: 12 }}>
                        {option.type === "serviceProvider"
                            ? "(Service Provider)"
                            : option.type === "customer"
                                ? "(Customer)"
                                : option.type === "agent"
                                    ? "(Global Agent)"
                                    : "(Manual)"}
                    </span>
                                                                    </>
                                                                )}
                                                            </li>
                                                        )}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Carrier"
                                                                InputLabelProps={{ shrink: true }}
                                                                sx={{
                                                                    "& .MuiInputBase-root": {
                                                                        height: 40,
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </Grid>

                                                <Grid item xs={1}>
                                                    <TextField
                                                        select
                                                        label="Charge Type"
                                                        value={row.chargeType}
                                                        onChange={(e) =>
                                                            handleCarrierChange(index, "chargeType", e.target.value)
                                                        }
                                                        fullWidth
                                                        sx={{"& .MuiInputBase-root": { height: 30 }}}
                                                    >
                                                        {/* "Air Freight" varsayılan değer ve mevcut kayıtlarda kullanılıyor; listede olmayınca alan boş görünüyordu */}
                                                        <MenuItem value="Air Freight">Air Freight</MenuItem>
                                                        <MenuItem value="Pre Carriage">Pre Carriage</MenuItem>
                                                        <MenuItem value="Air Freight Fee">Air Freight Fee</MenuItem>
                                                    </TextField>
                                                </Grid>

                                                <Grid item xs={2}>
                                                    <Autocomplete
                                                        options={countryOptions}
                                                        value={row.polCountry}
                                                        onChange={(_, v) => {
                                                            handleCarrierChange(index, "polCountry", v);
                                                            carrierAirportManualRef.current[`pol-${index}`] = "";
                                                            setCarrierAirportOptions((prev) => ({ ...prev, [index]: [] }));
                                                        }}
                                                        renderInput={(params) => <TextField {...params} label="POL Country" />}
                                                        sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                    />
                                                </Grid>

                                                <Grid item xs={2}>
                                                    <Autocomplete
                                                        freeSolo
                                                        options={carrierAirportOptions[index] || []}
                                                        filterOptions={(x) => x}
                                                        loading={false}
                                                        value={row.pol}
                                                        inputValue={row.polInput || ""}
                                                        getOptionLabel={(o) => (typeof o === "string" ? o : o?.label || "")}
                                                        isOptionEqualToValue={(o, v) => (o?.label || o) === (v?.label || v)}
                                                        onInputChange={(event, value, reason) => {
                                                            if (reason === "reset") return;

                                                            carrierAirportManualRef.current[`pol-${index}`] = value;

                                                            setCarriers((prev) =>
                                                                prev.map((r, i) =>
                                                                    i === index ? { ...r, polInput: value } : r
                                                                )
                                                            );

                                                            if (!row.polCountry || value.trim().length < 2) {
                                                                setCarrierAirportOptions((prev) => ({ ...prev, [index]: [] }));
                                                                return;
                                                            }

                                                            clearTimeout(carrierAirportTimersRef.current[`pol-${index}`]);

                                                            carrierAirportTimersRef.current[`pol-${index}`] = setTimeout(() => {
                                                                searchAirports({
                                                                    query: value,
                                                                    country: row.polCountry.label,
                                                                    setter: (opts) =>
                                                                        setCarrierAirportOptions((prev) => ({
                                                                            ...prev,
                                                                            [index]: opts,
                                                                        })),
                                                                    setLoading: () => {},
                                                                    key: `carrier-pol-${index}`,
                                                                });
                                                            }, 300);
                                                        }}
                                                        onChange={(e, value) => {
                                                            const airport =
                                                                typeof value === "string" ? { label: value } : value;

                                                            carrierAirportManualRef.current[`pol-${index}`] =
                                                                airport?.label || "";

                                                            setCarriers((prev) =>
                                                                prev.map((r, i) =>
                                                                    i === index
                                                                        ? {
                                                                            ...r,
                                                                            pol: airport,
                                                                            polInput: airport?.label || "",
                                                                        }
                                                                        : r
                                                                )
                                                            );
                                                        }}
                                                        onBlur={() => {
                                                            const manualValue =
                                                                row.polInput ||
                                                                carrierAirportManualRef.current[`pol-${index}`] ||
                                                                "";

                                                            if (manualValue && !row.pol) {
                                                                carrierAirportManualRef.current[`pol-${index}`] = manualValue;

                                                                setCarriers((prev) =>
                                                                    prev.map((r, i) =>
                                                                        i === index
                                                                            ? {
                                                                                ...r,
                                                                                pol: { label: manualValue },
                                                                                polInput: manualValue,
                                                                            }
                                                                            : r
                                                                    )
                                                                );
                                                            }
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField {...params} label="POL Airport" />
                                                        )}
                                                        sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                    />
                                                </Grid>

                                                <Grid item xs={2}>
                                                    <Autocomplete
                                                        options={countryOptions}
                                                        value={row.podCountry}
                                                        onChange={(_, v) => {
                                                            handleCarrierChange(index, "podCountry", v);
                                                            carrierAirportManualRef.current[`pod-${index}`] = "";
                                                            setCarrierAirportOptions((prev) => ({
                                                                ...prev,
                                                                [`pod-${index}`]: [],
                                                            }));
                                                        }}
                                                        renderInput={(params) => <TextField {...params} label="POD Country" />}
                                                        sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                    />
                                                </Grid>

                                                <Grid item xs={2}>
                                                    <Autocomplete
                                                        freeSolo
                                                        options={carrierAirportOptions[`pod-${index}`] || []}
                                                        filterOptions={(x) => x}
                                                        loading={false}
                                                        value={row.pod}
                                                        inputValue={row.podInput || ""}
                                                        getOptionLabel={(o) => (typeof o === "string" ? o : o?.label || "")}
                                                        isOptionEqualToValue={(o, v) => (o?.label || o) === (v?.label || v)}
                                                        onInputChange={(event, value, reason) => {
                                                            if (reason === "reset") return;

                                                            carrierAirportManualRef.current[`pod-${index}`] = value;

                                                            setCarriers((prev) =>
                                                                prev.map((r, i) =>
                                                                    i === index ? { ...r, podInput: value } : r
                                                                )
                                                            );

                                                            if (!row.podCountry || value.trim().length < 2) {
                                                                setCarrierAirportOptions((prev) => ({
                                                                    ...prev,
                                                                    [`pod-${index}`]: [],
                                                                }));
                                                                return;
                                                            }

                                                            clearTimeout(carrierAirportTimersRef.current[`pod-${index}`]);

                                                            carrierAirportTimersRef.current[`pod-${index}`] = setTimeout(() => {
                                                                searchAirports({
                                                                    query: value,
                                                                    country: row.podCountry.label,
                                                                    setter: (opts) =>
                                                                        setCarrierAirportOptions((prev) => ({
                                                                            ...prev,
                                                                            [`pod-${index}`]: opts,
                                                                        })),
                                                                    setLoading: () => {},
                                                                    key: `carrier-pod-${index}`,
                                                                });
                                                            }, 300);
                                                        }}
                                                        onChange={(e, value) => {
                                                            const airport =
                                                                typeof value === "string" ? { label: value } : value;

                                                            carrierAirportManualRef.current[`pod-${index}`] =
                                                                airport?.label || "";

                                                            setCarriers((prev) =>
                                                                prev.map((r, i) =>
                                                                    i === index
                                                                        ? {
                                                                            ...r,
                                                                            pod: airport,
                                                                            podInput: airport?.label || "",
                                                                        }
                                                                        : r
                                                                )
                                                            );
                                                        }}
                                                        onBlur={() => {
                                                            const manualValue =
                                                                row.podInput ||
                                                                carrierAirportManualRef.current[`pod-${index}`] ||
                                                                "";

                                                            if (manualValue && !row.pod) {
                                                                carrierAirportManualRef.current[`pod-${index}`] = manualValue;

                                                                setCarriers((prev) =>
                                                                    prev.map((r, i) =>
                                                                        i === index
                                                                            ? {
                                                                                ...r,
                                                                                pod: { label: manualValue },
                                                                                podInput: manualValue,
                                                                            }
                                                                            : r
                                                                    )
                                                                );
                                                            }
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField {...params} label="POD Airport" />
                                                        )}
                                                        sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                    />
                                                </Grid>

                                                <Grid item xs={1.2}>
                                                    <TextField
                                                        label="Cost"
                                                        type="number"
                                                        value={row.cost ?? ""}
                                                        onChange={(e) =>
                                                            handleCarrierChange(index, "cost", e.target.value)
                                                        }
                                                        fullWidth
                                                        sx={{"& .MuiInputBase-root": { height: 40 }}}
                                                    />
                                                </Grid>

                                                <Grid item xs={1.3}>
                                                    <TextField
                                                        select
                                                        value={row.currency}
                                                        onChange={(e) =>
                                                            handleCarrierChange(index, "currency", e.target.value)
                                                        }
                                                        fullWidth
                                                        sx={{"& .MuiInputBase-root": { height: 40 }}}
                                                    >
                                                        <MenuItem value="USD">USD</MenuItem>
                                                        <MenuItem value="EUR">EUR</MenuItem>
                                                        <MenuItem value="TRY">TRY</MenuItem>
                                                        <MenuItem value="GBP">GBP</MenuItem>
                                                    </TextField>
                                                </Grid>

                                                <Grid item xs={1.2}>
                                                    <TextField
                                                        label="Selling Rate"
                                                        type="number"
                                                        value={row.sellingCarriers ?? ""}
                                                        onChange={(e) =>
                                                            handleCarrierChange(index, "sellingCarriers", e.target.value)
                                                        }
                                                        fullWidth
                                                        sx={{"& .MuiInputBase-root": { height: 40 }}}
                                                    />
                                                </Grid>

                                                <Grid item xs={1.3}>
                                                    <TextField
                                                        select
                                                        value={row.sellingCarriersRate}
                                                        onChange={(e) =>
                                                            handleCarrierChange(index, "sellingCarriersRate", e.target.value)
                                                        }
                                                        fullWidth
                                                        sx={{"& .MuiInputBase-root": { height: 40 }}}
                                                    >
                                                        <MenuItem value="USD">USD</MenuItem>
                                                        <MenuItem value="EUR">EUR</MenuItem>
                                                        <MenuItem value="TRY">TRY</MenuItem>
                                                        <MenuItem value="GBP">GBP</MenuItem>
                                                    </TextField>
                                                </Grid>

                                                <Grid item xs={1} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                    {index === carriers.length - 1 && (
                                                        <AddRowButton onClick={addCarrier} tooltip="Add carrier" />
                                                    )}

                                                    {index > 0 && (
                                                        <RemoveRowButton onClick={() => removeCarrier(index)} tooltip="Remove carrier" />
                                                    )}
                                                </Grid>

                                            </Grid>
                                        ))}


                                        {/* ===================== EXTRA CHARGES ===================== */}
                                        <MDTypography variant="h6" mt={3} mb={1}>
                                            Extra Charges
                                        </MDTypography>

                                        {extraCosts.map((row, index) => (
                                            <Grid container spacing={2} alignItems="center" mb={1} key={index}>

                                                <Grid item xs={3}>
                                                    <Autocomplete
                                                        options={extraChargeOptions}
                                                        groupBy={(option) => option.group}
                                                        getOptionLabel={(option) => option.label}
                                                        value={
                                                            extraChargeOptions.find((o) => o.label === row.type) || null
                                                        }
                                                        onChange={(_, v) =>
                                                            handleExtraChange(index, "type", v?.label || "")
                                                        }
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Charge Type"
                                                                fullWidth
                                                                sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                            />
                                                        )}
                                                    />


                                                </Grid>

                                                <Grid item xs={2}>
                                                    <TextField
                                                        label="Cost"
                                                        type="number"
                                                        value={row.amount ?? ""}
                                                        onChange={(e) =>
                                                            handleExtraChange(index, "amount", e.target.value)
                                                        }
                                                        sx={{"& .MuiInputBase-root": { height: 40 }}}
                                                        fullWidth
                                                    />
                                                </Grid>

                                                <Grid item xs={1}>
                                                    <TextField
                                                        select
                                                        value={row.currency}
                                                        onChange={(e) =>
                                                            handleExtraChange(index, "currency", e.target.value)
                                                        }
                                                        fullWidth
                                                        sx={{"& .MuiInputBase-root": { height: 40 }}}
                                                    >
                                                        <MenuItem value="USD">USD</MenuItem>
                                                        <MenuItem value="EUR">EUR</MenuItem>
                                                        <MenuItem value="TRY">TRY</MenuItem>
                                                        <MenuItem value="GBP">GBP</MenuItem>
                                                    </TextField>
                                                </Grid>

                                                <Grid item xs={2}>
                                                    <TextField
                                                        label="Selling Rate"
                                                        type="number"
                                                        value={row.extraSelling ?? ""}
                                                        onChange={(e) =>
                                                            handleExtraChange(index, "extraSelling", e.target.value)
                                                        }
                                                        fullWidth
                                                        sx={{"& .MuiInputBase-root": { height: 40 }}}
                                                    />
                                                </Grid>

                                                <Grid item xs={1}>
                                                    <TextField
                                                        select
                                                        value={row.extraSellingRate}
                                                        onChange={(e) =>
                                                            handleExtraChange(index, "extraSellingRate", e.target.value)
                                                        }
                                                        fullWidth
                                                        sx={{"& .MuiInputBase-root": { height: 40 }}}
                                                    >
                                                        <MenuItem value="USD">USD</MenuItem>
                                                        <MenuItem value="EUR">EUR</MenuItem>
                                                        <MenuItem value="TRY">TRY</MenuItem>
                                                        <MenuItem value="GBP">GBP</MenuItem>
                                                    </TextField>
                                                </Grid>

                                                <Grid item xs={1} sx={{ display: "flex", gap: 1 }}>
                                                    {index === extraCosts.length - 1 && (
                                                        <AddRowButton onClick={addExtra} tooltip="Add charge" />
                                                    )}

                                                    {index > 0 && (
                                                        <RemoveRowButton onClick={() => removeExtra(index)} tooltip="Remove charge" />
                                                    )}
                                                </Grid>

                                            </Grid>
                                        ))}

                                        {/* ===================== SELLING RATE DETAILS ===================== */}
                                        <MDTypography variant="h6" mt={4} mb={2}>
                                            Selling Rate Details
                                        </MDTypography>

                                        <Grid container spacing={2}>

                                            <Grid item xs={3}>
                                                <TextField
                                                    label="Margin %"
                                                    type="number"
                                                    value={marginPercentInput}
                                                    onChange={(e) => {
                                                        setAirPricingMode("ALL_IN");
                                                        clearLineSelling();
                                                        setActiveSellingField("PERCENT");
                                                        setSellingDriver("PERCENT");
                                                        setMarginPercentInput(e.target.value);
                                                    }}
                                                    onFocus={() => setActiveSellingField("PERCENT")}
                                                    onBlur={() => setActiveSellingField(null)}
                                                    fullWidth
                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                />
                                            </Grid>

                                            <Grid item xs={3}>
                                                <TextField
                                                    label={`Margin per ${baseCurrency}`}
                                                    type="number"
                                                    value={marginUnitInput}
                                                    onChange={(e) => {
                                                        setAirPricingMode("ALL_IN");
                                                        clearLineSelling();
                                                        setActiveSellingField("UNIT");
                                                        setSellingDriver("UNIT");
                                                        setMarginUnitInput(e.target.value);
                                                    }}
                                                    onFocus={() => setActiveSellingField("UNIT")}
                                                    onBlur={() => setActiveSellingField(null)}
                                                    fullWidth
                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                />
                                            </Grid>

                                            <Grid item xs={3}>
                                                <TextField
                                                    label="Selling Rate"
                                                    type="number"
                                                    value={sellingRateInput}
                                                    onChange={(e) => {
                                                        setAirPricingMode("ALL_IN");
                                                        clearLineSelling();
                                                        setActiveSellingField("SELLING");
                                                        setSellingDriver("SELLING");
                                                        setSellingRateInput(e.target.value);
                                                    }}
                                                    onFocus={() => setActiveSellingField("SELLING")}
                                                    onBlur={() => setActiveSellingField(null)}
                                                    fullWidth
                                                    sx={{ "& .MuiInputBase-root": { height: 40 } }}
                                                />
                                            </Grid>

                                            <Grid item xs={3}>
                                                <TextField
                                                    select
                                                    label="Currency"
                                                    value={currency}
                                                    onChange={(e) => setCurrency(e.target.value)}
                                                    fullWidth
                                                    sx={{"& .MuiInputBase-root": { height: 40 }}}
                                                >
                                                    <MenuItem value="USD">USD</MenuItem>
                                                    <MenuItem value="EUR">EUR</MenuItem>
                                                    <MenuItem value="TRY">TRY</MenuItem>
                                                    <MenuItem value="GBP">GBP</MenuItem>
                                                </TextField>
                                            </Grid>
                                        </Grid>


                                    </Grid>
                                    {/* BUYING / SELLING SUMMARY CARD */}
                                    <MDBox
                                        mt={4}
                                        p={2.5}
                                        sx={{
                                            borderRadius: 2,
                                            backgroundColor: "#ffffff",
                                            border: "1px solid #e5e7eb",
                                            boxShadow: "none",
                                        }}
                                    >
                                        <Box
                                            display="flex"
                                            justifyContent="space-between"
                                            alignItems="center"
                                            mb={2}
                                            gap={2}
                                        >
                                            <Box>
                                                <MDTypography variant="h6" fontWeight="bold">
                                                    Buying / Selling Summary
                                                </MDTypography>
                                                <MDTypography
                                                    variant="caption"
                                                    color="text"
                                                    sx={{ opacity: 0.7 }}
                                                >
                                                    Line items retain their selected currencies. Totals are converted to the carrier currency.
                                                </MDTypography>
                                            </Box>

                                            {loadingRates && (
                                                <MDTypography
                                                    variant="caption"
                                                    sx={{ color: "#ed6c02", whiteSpace: "nowrap" }}
                                                >
                                                    Loading exchange rates...
                                                </MDTypography>
                                            )}
                                        </Box>

                                        <MDBox
                                            p={1.75}
                                            sx={{
                                                borderRadius: 2,
                                                backgroundColor: "#ffffff",
                                                border: "1px solid #e5e7eb",
                                                boxShadow: "none",
                                            }}
                                        >
                                            <Box
                                                display="flex"
                                                justifyContent="space-between"
                                                alignItems="center"
                                                flexWrap="wrap"
                                                gap={1}
                                                mb={1.5}
                                            >
                                                <Box>
                                                    <MDTypography variant="button" fontWeight="bold" display="block">
                                                        Air Freight Summary
                                                    </MDTypography>
                                                    <MDTypography
                                                        variant="caption"
                                                        color="text"
                                                        sx={{ opacity: 0.65 }}
                                                    >
                                                        Carrier, pickup, delivery and extra charge totals
                                                    </MDTypography>
                                                </Box>

                                                <Box display="flex" gap={1} flexWrap="wrap">
                                                    <Box
                                                        sx={{
                                                            px: 1.25,
                                                            py: 0.5,
                                                            borderRadius: 1.5,
                                                            fontSize: 11,
                                                            fontWeight: 600,
                                                            color: "#475569",
                                                            backgroundColor: "#f1f5f9",
                                                        }}
                                                    >
                                                        Buying: {summaryBuyingCurrency}
                                                    </Box>
                                                    <Box
                                                        sx={{
                                                            px: 1.25,
                                                            py: 0.5,
                                                            borderRadius: 1.5,
                                                            fontSize: 11,
                                                            fontWeight: 600,
                                                            color: "#166534",
                                                            backgroundColor: "#dcfce7",
                                                        }}
                                                    >
                                                        Selling: {summarySellingCurrency}
                                                    </Box>
                                                </Box>
                                            </Box>

                                            <Grid container spacing={1.5}>
                                                {/* BUYING CARD */}
                                                <Grid item xs={12} md={6}>
                                                    <MDBox
                                                        sx={{
                                                            height: "100%",
                                                            p: 1.5,
                                                            borderRadius: 1.5,
                                                            backgroundColor: "#f8fafc",
                                                            border: "1px solid #e2e8f0",
                                                        }}
                                                    >
                                                        <Box
                                                            display="flex"
                                                            justifyContent="space-between"
                                                            alignItems="flex-start"
                                                            gap={2}
                                                            pb={1}
                                                            mb={1}
                                                            sx={{ borderBottom: "1px solid #e2e8f0" }}
                                                        >
                                                            <Box>
                                                                <MDTypography variant="caption" fontWeight="bold" display="block">
                                                                    Buying Total
                                                                </MDTypography>
                                                                <MDTypography variant="caption" color="text" sx={{ opacity: 0.6 }}>
                                                                    Converted to {summaryBuyingCurrency}
                                                                </MDTypography>
                                                            </Box>
                                                            <MDTypography
                                                                variant="caption"
                                                                fontWeight="bold"
                                                                textAlign="right"
                                                                sx={{ color: "#0f172a" }}
                                                            >
                                                                {formatSummaryAmount(summaryTotalBuying)} {summaryBuyingCurrency}
                                                            </MDTypography>
                                                        </Box>

                                                        {carrierBuyingRows.map((row) => (
                                                            <Box
                                                                key={row.key}
                                                                display="flex"
                                                                justifyContent="space-between"
                                                                alignItems="center"
                                                                gap={2}
                                                                mb={0.75}
                                                            >
                                                                <MDTypography variant="caption">{row.label}</MDTypography>
                                                                <MDTypography variant="caption" fontWeight="medium" textAlign="right">
                                                                    {formatSummaryAmount(row.amount)} {summaryBuyingCurrency}
                                                                </MDTypography>
                                                            </Box>
                                                        ))}

                                                        {hasPickupService && (
                                                            <Box display="flex" justifyContent="space-between" alignItems="center" gap={2} mb={0.75}>
                                                                <MDTypography variant="caption">Pickup Cost</MDTypography>
                                                                <MDTypography variant="caption" textAlign="right">
                                                                    {formatSummaryAmount(pickupCostForSummary)} {summaryBuyingCurrency}
                                                                </MDTypography>
                                                            </Box>
                                                        )}

                                                        {hasDeliveryService && (
                                                            <Box display="flex" justifyContent="space-between" alignItems="center" gap={2} mb={0.75}>
                                                                <MDTypography variant="caption">Delivery Cost</MDTypography>
                                                                <MDTypography variant="caption" textAlign="right">
                                                                    {formatSummaryAmount(deliveryCostForSummary)} {summaryBuyingCurrency}
                                                                </MDTypography>
                                                            </Box>
                                                        )}

                                                        {extraBuyingRows.map((row) => (
                                                            <Box
                                                                key={row.key}
                                                                display="flex"
                                                                justifyContent="space-between"
                                                                alignItems="center"
                                                                gap={2}
                                                                mb={0.75}
                                                            >
                                                                <MDTypography variant="caption">{row.label}</MDTypography>
                                                                <MDTypography variant="caption" textAlign="right">
                                                                    {formatSummaryAmount(row.amount)} {summaryBuyingCurrency}
                                                                </MDTypography>
                                                            </Box>
                                                        ))}

                                                        {carrierBuyingRows.length === 0 &&
                                                            extraBuyingRows.length === 0 &&
                                                            !hasPickupService &&
                                                            !hasDeliveryService && (
                                                                <MDTypography variant="caption" color="text" sx={{ opacity: 0.55 }}>
                                                                    No additional buying costs
                                                                </MDTypography>
                                                            )}
                                                    </MDBox>
                                                </Grid>

                                                {/* SELLING CARD */}
                                                <Grid item xs={12} md={6}>
                                                    <MDBox
                                                        sx={{
                                                            height: "100%",
                                                            p: 1.5,
                                                            borderRadius: 1.5,
                                                            backgroundColor: "#f0fdf4",
                                                            border: "1px solid #bbf7d0",
                                                        }}
                                                    >
                                                        <Box
                                                            display="flex"
                                                            justifyContent="space-between"
                                                            alignItems="flex-start"
                                                            gap={2}
                                                            pb={1}
                                                            mb={1}
                                                            sx={{ borderBottom: "1px solid #bbf7d0" }}
                                                        >
                                                            <Box>
                                                                <MDTypography variant="caption" fontWeight="bold" display="block">
                                                                    Selling Total
                                                                </MDTypography>
                                                                <MDTypography variant="caption" color="text" sx={{ opacity: 0.6 }}>
                                                                    Converted to {summarySellingCurrency}
                                                                </MDTypography>
                                                            </Box>
                                                            <MDTypography
                                                                variant="caption"
                                                                fontWeight="bold"
                                                                textAlign="right"
                                                                sx={{ color: "#15803d" }}
                                                            >
                                                                {formatSummaryAmount(summaryTotalSelling)} {summarySellingCurrency}
                                                            </MDTypography>
                                                        </Box>

                                                        <Box display="flex" justifyContent="space-between" alignItems="center" gap={2} mb={0.75}>
                                                            <MDTypography variant="caption">
                                                                {airPricingMode === "BREAKDOWN"
                                                                    ? "Air Freight Selling"
                                                                    : "All-in Air Selling"}
                                                            </MDTypography>
                                                            <MDTypography variant="caption" fontWeight="medium" textAlign="right">
                                                                {formatSummaryAmount(combinedAirFreightSelling)} {summarySellingCurrency}
                                                            </MDTypography>
                                                        </Box>

                                                        {extraSellingRows.map((row) => (
                                                            <Box
                                                                key={row.key}
                                                                display="flex"
                                                                justifyContent="space-between"
                                                                alignItems="center"
                                                                gap={2}
                                                                mb={0.75}
                                                            >
                                                                <MDTypography variant="caption">{row.label}</MDTypography>
                                                                <MDTypography variant="caption" textAlign="right">
                                                                    {formatSummaryAmount(row.amount)} {summarySellingCurrency}
                                                                </MDTypography>
                                                            </Box>
                                                        ))}

                                                        {extraSellingRows.length === 0 && combinedAirFreightSelling === 0 && (
                                                            <MDTypography variant="caption" color="text" sx={{ opacity: 0.55 }}>
                                                                No selling items
                                                            </MDTypography>
                                                        )}
                                                    </MDBox>
                                                </Grid>
                                            </Grid>
                                        </MDBox>
                                    </MDBox>


                                    <Grid container spacing={3} mt={2}>
                                        <Grid item xs={12}>
                                            <TextField
                                                type="text"
                                                label="Description"
                                                value={description}
                                                onChange={(e) => setDescription(e.target.value)}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                fullWidth
                                            />
                                        </Grid>
                                    </Grid>



                                    <br/>

                                    <Grid container spacing={3}>
                                        <Grid item xs={12} sm={3}>
                                            <Autocomplete
                                                options={statusOptions}
                                                getOptionLabel={(o) => o.label}
                                                value={statusOptions.find((o) => o.value === selectedStatus || o.label === selectedStatus) || null}
                                                onChange={(e, newValue) => setSelectedStatus(newValue?.value || newValue?.label || "")}
                                                isOptionEqualToValue={(opt, val) => opt?.value === val?.value}
                                                renderOption={({ key: optionKey, ...props }, option) => (
                                                    <li key={optionKey} {...props} style={{ display: "flex", alignItems: "center" }}>
                                                        <Dot color={option.color} />
                                                        {option.label}
                                                    </li>
                                                )}
                                                renderInput={(params) => {
                                                    const current =
                                                        statusOptions.find((o) => o.value === selectedStatus || o.label === selectedStatus) || null;

                                                    return (
                                                        <TextField
                                                            {...params}
                                                            label="Select Business Status"
                                                            variant="outlined"
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{
                                                                ...inputStyle,
                                                                "& .MuiInputBase-root": { alignItems: "center" }, // ✅ input satırını ortala
                                                            }}
                                                            InputProps={{
                                                                ...params.InputProps,
                                                                startAdornment: (
                                                                    <span style={{ display: "flex", alignItems: "center", marginRight: 6 }}>
                                                                            <Dot color={current?.color} />
                                                                        {params.InputProps.startAdornment}
                                                                        </span>
                                                                ),
                                                            }}
                                                        />
                                                    );
                                                }}

                                            />

                                        </Grid>
                                    </Grid>
                                </MDBox>
                            </Grid>
                        </Grid>
                    </MDBox>
                    <div>
                        <form onSubmit={submitHandler}>
                            <Button
                                variant="contained"
                                onClick={submitHandler}
                                disabled={loading || !!successMessage}
                                style={{backgroundColor: "#0B1F3A", color: "#FFFFFF"}}
                            >
                                {isEditing ? "Update Air Quote" : "Create Air Quote"}
                            </Button>
                        </form>
                    </div>
                </MDBox>
            </Grid>
            <Dialog
                open={customerModalOpen}
                onClose={() => setCustomerModalOpen(false)}
                maxWidth="xl"
                fullWidth
            >
                <DialogTitle>
                    Create Customer

                    <IconButton
                        onClick={() => setCustomerModalOpen(false)}
                        sx={{
                            position: "absolute",
                            right: 12,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    <CreateCustomer
                        isModal
                        onClose={() => setCustomerModalOpen(false)}
                        onCreated={handleCustomerCreatedFromModal}
                    />
                </DialogContent>
            </Dialog>
            <Dialog
                open={serviceProviderModalOpen}
                onClose={() => setServiceProviderModalOpen(false)}
                maxWidth="xl"
                fullWidth
            >
                <DialogTitle>
                    Create Service Provider

                    <IconButton
                        onClick={() => setServiceProviderModalOpen(false)}
                        sx={{
                            position: "absolute",
                            right: 12,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    <CreateServiceProvider
                        isModal
                        onClose={() => setServiceProviderModalOpen(false)}
                        onCreated={handleServiceProviderCreatedFromModal}
                    />
                </DialogContent>
            </Dialog>
        </Grid>
    );
};

export default AirForm;